<template>
  <div class="AllPwaMobile manualService">
    <div v-if="LoadingBoxes" class="mapLoading">
      <div class="sk-cube-grid">
        <div class="sk-cube sk-cube1"></div>
        <div class="sk-cube sk-cube2"></div>
        <div class="sk-cube sk-cube3"></div>
        <div class="sk-cube sk-cube4"></div>
        <div class="sk-cube sk-cube5"></div>
        <div class="sk-cube sk-cube6"></div>
        <div class="sk-cube sk-cube7"></div>
        <div class="sk-cube sk-cube8"></div>
        <div class="sk-cube sk-cube9"></div>
      </div>
    </div>

    <div>
      <div
        v-if="step1 != 10 && step1 != 1"
        id="ClosePage4"
        @click="ClosePage4()"
      >
        <svg
          width="800px"
          height="800px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 12H18M18 12L13 7M18 12L13 17"
            stroke="#fff"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <RouterLink v-if="step1 == 10" id="ClosePage4" to="/">
        <VsxIcon iconName="Home" :size="24" color="#fff" type="linear" />
      </RouterLink>

      <div>
        <div>
          <NeshanMap
            v-if="NeshanMapLoad"
            :mapKey="$store.state.taxi_c_set.map_info?.map_key"
            :serviceKey="service_api"
            :zoom="14"
            :poi="true"
            :traffic="true"
            :hide-search-container="true"
            :center="center"
            @on-init="getmounted"
            :reverse-on-click="false"
            :hide-layers="true"
            class="ClassPositionLayers"
          />
        </div>

        <div
          @click="
            ReverseLocationToAddress(
              markerPosition.latitude,
              markerPosition.longitude
            )
          "
          class="markerTY"
        >
          <div v-if="step1 == 10" class="customMarker">
            <div class="markerHead">
              <div class="headPoint"></div>
              <div class="headContainer">
                <span>مبدا</span>
              </div>
            </div>
            <div class="markerPin"></div>
            <div class="markerSadow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <g id=".Pin_Dot">
                  <ellipse
                    id="Ellipse 1"
                    cx="6"
                    cy="2"
                    rx="4"
                    ry="2"
                    fill="black"
                    fill-opacity="0.12"
                  />
                </g>
              </svg>
              <div class="shadowColored">
                <div class="coloredCenter"></div>
              </div>
            </div>
          </div>
          <!-- <img v-if="step1 == 10" src="../assets/img/marker1.png" alt=""> -->
          <div v-if="step1 == 1" class="customMarker">
            <div class="markerHead">
              <div class="headPoint"></div>
              <div class="headContainer">
                <span>مبدا</span>
              </div>
            </div>
            <div class="markerPin"></div>
            <div class="markerSadow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <g id=".Pin_Dot">
                  <ellipse
                    id="Ellipse 1"
                    cx="6"
                    cy="2"
                    rx="4"
                    ry="2"
                    fill="black"
                    fill-opacity="0.12"
                  />
                </g>
              </svg>
              <div class="shadowColored">
                <div class="coloredCenter"></div>
              </div>
            </div>
          </div>
          <!-- <img v-if="step1 == 1" src="../assets/img/marker1.png" alt=""> -->
          <div v-if="step1 == 2" class="customMarker destination">
            <div class="markerHead">
              <div class="headPoint"></div>
              <div class="headContainer">
                <span>مقصد</span>
              </div>
            </div>
            <div class="markerPin"></div>
            <div class="markerSadow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <g id=".Pin_Dot">
                  <ellipse
                    id="Ellipse 1"
                    cx="6"
                    cy="2"
                    rx="4"
                    ry="2"
                    fill="black"
                    fill-opacity="0.12"
                  />
                </g>
              </svg>
              <div class="shadowColored">
                <div class="coloredCenter"></div>
              </div>
            </div>
          </div>
          <!-- <img v-if="step1 == 2" src="../assets/img/marker2.png" alt=""> -->
          <div v-if="step1 == 3" class="customMarker destination2">
            <div class="markerHead">
              <div class="headPoint"></div>
              <div class="headContainer">
                <span>مقصد 2</span>
              </div>
            </div>
            <div class="markerPin"></div>
            <div class="markerSadow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <g id=".Pin_Dot">
                  <ellipse
                    id="Ellipse 1"
                    cx="6"
                    cy="2"
                    rx="4"
                    ry="2"
                    fill="black"
                    fill-opacity="0.12"
                  />
                </g>
              </svg>
              <div class="shadowColored">
                <div class="coloredCenter"></div>
              </div>
            </div>
          </div>
          <!-- <img v-if="step1 == 3" src="../assets/img/marker3.png" alt=""> -->
        </div>
      </div>
      <div class="PosAbShowCount optionsContainer">
        <div class="location-btn">
          <VsxIcon
            @click="get_loc('', '', 'f')"
            iconName="Location"
            :size="26"
            color="#fff"
            type="linear"
          />
        </div>
        <div class="ManualServiceStepOne" v-if="step == 1">
          <div class="ShowStyleFlexStep">
            <div
              class="ShowStyleFlexStepV"
              :style="BtnStyle"
              @click="OpenModel1"
            >
              <!-- <VsxIcon
                iconName="SearchNormal1"
                :size="25"
                color="#5584FF"
                type="linear"
              /> -->

              <div>
                <h4 v-if="markerOne == ''" style="font-weight: 400">
                  کجا هستید ؟
                </h4>
                <h4 v-if="markerOne != ''">{{ markerOne.name }}</h4>

                <!-- <VsxIcon iconName="Gps" :size="18" color="#5584FF" type="linear" /> -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                  />
                </svg>
              </div>
            </div>

            <!--              orgine history-->
            <!-- <div v-if="history_map_list.length > 0" class="ShowStyleHistory">
              <div @click="BtnSendData(history_map_list[0], 'history')">
                <h4>{{ history_map_list[0].address }}</h4>
                <VsxIcon
                  iconName="Clock"
                  :size="17"
                  color="#5584FF"
                  type="linear"
                />
              </div>
              <hr />
              <div @click="BtnSendData(history_map_list[1], 'history')">
                <h4>{{ history_map_list[1].address }}</h4>
                <VsxIcon
                  iconName="Clock"
                  :size="17"
                  color="#5584FF"
                  type="linear"
                />
              </div>
            </div> -->

            <div
              class="BtnSearchNormal1"
              @click="
                ReverseLocationToAddress(
                  markerPosition.latitude,
                  markerPosition.longitude
                )
              "
            >
              تایید مبدا
            </div>
          </div>
          <br />
        </div>
        <div class="ManualServiceStepOne secondStep" v-if="step == 2">
          <div class="ShowStyleFlexStep">
            <!--              <div :style="BtnStyle" class="ShowStyleFlexStepV">-->
            <!--                <VsxIcon iconName="SearchNormal1" :size="25" color="#5584FF" type="linear" />-->

            <!--                <h4 v-if="markerOne == ''">کجا هستید ؟</h4>-->
            <!--                <h4 v-if="markerOne != ''"-->
            <!--                    style="font-weight: 400;color: green;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;direction: rtl;">-->
            <!--                  {{ markerOne.name }}</h4>-->
            <!--              </div>-->

            <div
              :style="BtnStyle1"
              @click="OpenModel1"
              class="ShowStyleFlexStepV"
            >
              <!-- <VsxIcon
                iconName="SearchNormal1"
                :size="25"
                color="#5584FF"
                type="linear"
              /> -->

              <div>
                <h4 v-if="markerTwo == ''" style="font-weight: 400">
                  کجا می روید ؟
                </h4>
                <h4 v-if="markerTwo != ''">{{ markerTwo.name }}</h4>

                <!-- <VsxIcon iconName="Gps" :size="18" color="#5584FF" type="linear" /> -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                  />
                </svg>
              </div>
            </div>

            <!--              d1 history-->
            <!-- <div v-if="history_map_list.length > 0" class="ShowStyleHistory">
              <div @click="BtnSendData(history_map_list[0], 'history')">
                <h4>{{ history_map_list[0].address }}</h4>
                <VsxIcon
                  iconName="Clock"
                  :size="17"
                  color="#5584FF"
                  type="linear"
                />
              </div>
              <hr />
              <div @click="BtnSendData(history_map_list[1], 'history')">
                <h4>{{ history_map_list[1].address }}</h4>
                <VsxIcon
                  iconName="Clock"
                  :size="17"
                  color="#5584FF"
                  type="linear"
                />
              </div>
            </div> -->

            <div
              class="BtnSearchNormal1"
              @click="
                ReverseLocationToAddress(
                  markerPosition.latitude,
                  markerPosition.longitude
                )
              "
            >
              تایید مقصد
            </div>
          </div>
        </div>
        <div v-if="step == 3" class="ManualServiceStepOne secondStep">
          <div class="destionationThumb">
            <div class="thumbIcon circle"></div>
            <div class="thumbInfo infoTitle">
              <div class="thumbTitle">مبدا:</div>
              <div class="thumbValue">
                <span v-if="markerOne == ''">کجا هستید ؟</span>
                <span v-else>{{ markerOne.name }}</span>
              </div>
            </div>
          </div>
          <div
            class="destionationThumb"
            :class="{ beforeLastmarker: !Lastmarker }"
          >
            <div class="thumbIcon square"></div>
            <div class="thumbInfo infoTitle">
              <div class="thumbTitle">مقصد:</div>
              <div class="thumbValue">
                <span v-if="markerOne == ''">کجا میخواهید بروید ؟</span>
                <span v-else>{{ markerTwo.name }}</span>
              </div>
            </div>
          </div>
          <div v-if="Lastmarker" class="destionationThumb Lastmarker">
            <div class="thumbIcon square"></div>
            <div class="thumbInfo infoTitle">
              <div class="thumbTitle">مقصد دوم:</div>
              <div class="thumbValue">
                <span>{{ markerThree.name }}</span>
              </div>
            </div>
          </div>
          <!-- <div class="ShowStyleFlexStepV">
            <span style="font-size: 0.8rem"> مبدا</span>

            <p v-if="markerOne == ''" style="color: green">کجا هستید ؟</p>
            <p
              v-if="markerOne != ''"
              style="
                font-weight: 400;
                color: green;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                direction: rtl;
              "
            >
              {{ markerOne.name }}
            </p>
          </div>
          <div class="ShowStyleFlexStepV">
            <span style="font-size: 0.8rem"> مقصد</span>

            <p v-if="markerTwo == ''" style="color: green">کجا میخوای بری ؟</p>
            <p
              v-if="markerTwo != ''"
              style="
                font-weight: 400;
                color: green;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                direction: rtl;
              "
            >
              {{ markerTwo.name }}
            </p>
          </div>
          <div v-if="Lastmarker" class="ShowStyleFlexStepV">
            <span style="font-size: 0.8rem"> مقصد دوم</span>

            <p
              style="
                font-weight: 400;
                color: green;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                direction: rtl;
              "
            >
              {{ markerThree.name }}
            </p>
          </div> -->
          <div class="BtnSearchNormal1" @click="BtnShowIt3">درخواست خودرو</div>

          <vue-bottom-sheet ref="sheet3" style="z-index: 1050" v-model="sheet3">
            <v-sheet class="text-center custom-sheet">
              <div>
                <div class="classShowTypeCar travelTypesList">
                  <div
                    @click="choose_car(newListGet[1][0], 'lady')"
                    class="typeThumb"
                    :class="[
                      { active: CarType == 'lady' },
                      { noBorder: CarType == 'airline' },
                    ]"
                  >
                    <div class="thumbInfo">
                      <div class="infoIcon womenIcon">
                        <img src="@/assets/images/icons/option3.png" alt="" />
                      </div>
                      <div class="infoContent">
                        <div class="contentTitle">بانوان</div>
                        <div class="contentSubtitle">سواری</div>
                      </div>
                    </div>
                    <div
                      class="thumbPrice"
                      :class="{ thumbPriceLaoding: LoadingFalse }"
                    >
                      <div v-if="!LoadingFalse">
                        {{ formatPrice(newListGet[1][0]) }} <span>تومان</span>
                      </div>
                      <div v-if="LoadingFalse" class="priceLoader"></div>
                    </div>
                  </div>
                </div>

                <div class="RightSelectButtonGEt">
                  <div
                    @click="$refs.moreSelect.open()"
                    class="ChildRightSelectButtonGEt"
                  >
                    <svg
                      fill="#0851a0"
                      width="800px"
                      height="800px"
                      viewBox="0 0 256 256"
                      id="Flat"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M204,128a12.00028,12.00028,0,0,1-12,12H64a12,12,0,0,1,0-24H192A12.00028,12.00028,0,0,1,204,128Zm28-60H24a12,12,0,0,0,0,24H232a12,12,0,0,0,0-24Zm-80,96H104a12,12,0,0,0,0,24h48a12,12,0,0,0,0-24Z"
                      />
                    </svg>
                    <p>گزینه‌های سفر</p>
                  </div>
                  <div
                    @click="opendiscount()"
                    class="ChildRightSelectButtonGEt"
                  >
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10.5886 4.0007a1 1 0 0 1 .7069.2926l7.9979 7.9929c.3909.3906.3909 1.0241 0 1.4147l-5.5948 5.5907c-.3906.3903-1.0237.3902-1.4141-.0004l-7.9916-7.9938a.9999.9999 0 0 1-.2928-.707V5.0007c0-.5523.4477-1 1-1h5.5885ZM11.0025 2c.5302 0 1.0387.2105 1.4138.5853l8.9993 8.9936c.7817.7812.7816 2.0483-.0001 2.8294l-7.0104 7.0053c-.7813.7806-2.0473.7803-2.8281-.0007L2.5856 12.419A2 2 0 0 1 2 11.005V4c0-1.1046.8954-2 2-2h7.0025ZM7.502 9.0012c-.83 0-1.5-.6703-1.5-1.5005 0-.8303.67-1.5005 1.5-1.5005s1.5001.6702 1.5001 1.5005c0 .8302-.67 1.5005-1.5 1.5005Z"
                      ></path>
                    </svg>
                    <p>تخفیف</p>
                  </div>
                </div>

                <div
                  style="margin-bottom: 20px"
                  class="ShowClickGetTaxiDriver submitRequestBtn"
                  v-if="!loading"
                  @click="req_car()"
                >
                  ثبت درخواست
                </div>
                <div
                  style="padding-top: 5px"
                  class="ShowClickGetTaxiDriver submitRequestBtn"
                  v-if="loading"
                >
                  <span class="whiteLoader"></span>
                </div>
              </div>
            </v-sheet>
          </vue-bottom-sheet>
          <vue-bottom-sheet ref="moreSelect" style="z-index: 1050">
            <v-sheet class="text-center custom-sheet">
              <div class="travelCustomOptions">
                <div class="optionsInputGroup">
                  <div class="groupLabelWrapper">
                    <div class="labelIcon">
                      <svg
                        fill="#333"
                        width="800px"
                        height="800px"
                        viewBox="0 0 32 32"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M 19 0 L 19 2 C 25.065 2 30 6.935 30 13 L 32 13 C 32 5.832 26.168 0 19 0 z M 8.6503906 3.0058594 C 8.1255067 3.0058594 7.6010996 3.1771036 7.1738281 3.5214844 L 7.125 3.5605469 L 3.9804688 6.8046875 L 4.046875 6.7421875 C 3.0062406 7.6384134 2.7194504 9.0541178 3.1660156 10.244141 C 4.0086833 12.674074 6.1568506 17.372953 10.394531 21.605469 C 14.641274 25.857394 19.389499 27.91343 21.738281 28.830078 L 21.761719 28.837891 L 21.785156 28.845703 C 22.999558 29.252758 24.311449 28.962441 25.251953 28.158203 L 25.28125 28.132812 L 28.40625 25.007812 C 29.235762 24.178301 29.235762 22.724043 28.40625 21.894531 L 24.308594 17.792969 C 23.476725 16.9611 22.023275 16.9611 21.191406 17.792969 L 19.207031 19.777344 C 18.496637 19.438281 16.74879 18.558644 15.087891 16.974609 C 13.448585 15.411343 12.61169 13.604382 12.308594 12.90625 L 14.308594 10.90625 C 15.186189 10.028655 15.236115 8.5219515 14.224609 7.7167969 L 14.316406 7.8007812 L 10.173828 3.5605469 L 10.126953 3.5214844 C 9.6996708 3.1771284 9.1752746 3.0058594 8.6503906 3.0058594 z M 19 4 L 19 6 C 22.859 6 26 9.14 26 13 L 28 13 C 28 8.038 23.963 4 19 4 z M 8.6523438 5 C 8.7236064 4.9998777 8.7939074 5.026734 8.8632812 5.0800781 L 12.929688 9.2441406 L 12.978516 9.2832031 C 12.967016 9.2740531 13.016941 9.3697821 12.894531 9.4921875 L 9.9375 12.449219 L 10.166016 13.052734 C 10.166016 13.052734 11.294663 16.121404 13.707031 18.421875 C 16.079259 20.684317 19.003906 21.919922 19.003906 21.919922 L 19.626953 22.185547 L 22.605469 19.207031 C 22.7736 19.0389 22.7264 19.0389 22.894531 19.207031 L 26.992188 23.308594 C 27.162675 23.479082 27.162676 23.423262 26.992188 23.59375 L 23.945312 26.640625 C 23.481361 27.034971 23.00205 27.13833 22.425781 26.947266 C 20.163651 26.062686 15.739269 24.126878 11.808594 20.191406 C 7.8506547 16.238292 5.7997308 11.746595 5.046875 9.5703125 L 5.0429688 9.5585938 L 5.0371094 9.5449219 C 4.8856915 9.1444833 4.9963719 8.5637134 5.3515625 8.2578125 L 5.3847656 8.2285156 L 8.4394531 5.0800781 C 8.508857 5.0272234 8.5810811 5.0001223 8.6523438 5 z M 19 8 L 19 10 C 20.654 10 22 11.346 22 13 L 24 13 C 24 10.243 21.757 8 19 8 z"
                        />
                      </svg>
                    </div>
                    <div class="groupLabel">تلفن تماس</div>
                  </div>
                  <div class="groupInputWrapper">
                    <input
                      type="text"
                      class="groupInput phoneInput"
                      maxlength="11"
                      v-model="phone"
                      inputmode="numeric"
                    />
                  </div>
                </div>
                <div class="optionsInputGroup">
                  <div class="groupLabelWrapper">
                    <div class="labelIcon">
                      <svg
                        width="800px"
                        height="800px"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M9.25 2C9.25 1.58579 9.58579 1.25 10 1.25H14C14.4142 1.25 14.75 1.58579 14.75 2C14.75 2.41421 14.4142 2.75 14 2.75H10C9.58579 2.75 9.25 2.41421 9.25 2ZM12 4.75C7.44365 4.75 3.75 8.44365 3.75 13C3.75 17.5564 7.44365 21.25 12 21.25C16.5563 21.25 20.25 17.5564 20.25 13C20.25 8.44365 16.5563 4.75 12 4.75ZM2.25 13C2.25 7.61522 6.61522 3.25 12 3.25C17.3848 3.25 21.75 7.61522 21.75 13C21.75 18.3848 17.3848 22.75 12 22.75C6.61522 22.75 2.25 18.3848 2.25 13Z"
                          fill="#333"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M14.5587 8.23877H14.5152C14.3009 8.23876 14.1041 8.23875 13.9387 8.25003C13.7611 8.26215 13.5658 8.28976 13.3673 8.37198C12.9385 8.5496 12.5978 8.89028 12.4202 9.31907C12.3379 9.51758 12.3103 9.71292 12.2982 9.89056C12.2869 10.0559 12.2869 10.2527 12.287 10.467V15.5105C12.2869 15.7248 12.2869 15.9217 12.2982 16.087C12.3103 16.2646 12.3379 16.46 12.4202 16.6585C12.5978 17.0873 12.9385 17.4279 13.3673 17.6056C13.5658 17.6878 13.7611 17.7154 13.9387 17.7275C14.1041 17.7388 14.3009 17.7388 14.5152 17.7388H14.5587C14.773 17.7388 14.9698 17.7388 15.1352 17.7275C15.3128 17.7154 15.5082 17.6878 15.7067 17.6056C16.1355 17.4279 16.4761 17.0873 16.6537 16.6585C16.736 16.46 16.7636 16.2646 16.7757 16.087C16.787 15.9217 16.787 15.7248 16.787 15.5105V10.467C16.787 10.2527 16.787 10.0559 16.7757 9.89056C16.7636 9.71292 16.736 9.51758 16.6537 9.31907C16.4761 8.89028 16.1355 8.5496 15.7067 8.37198C15.5082 8.28976 15.3128 8.26215 15.1352 8.25003C14.9698 8.23875 14.773 8.23876 14.5587 8.23877ZM13.9383 9.75907C13.8794 9.78435 13.8325 9.83125 13.8073 9.89008C13.8054 9.89743 13.7993 9.92584 13.7947 9.99267C13.7874 10.1007 13.787 10.2455 13.787 10.4888V15.4888C13.787 15.732 13.7874 15.8769 13.7947 15.9849C13.7993 16.0517 13.8054 16.0801 13.8073 16.0875C13.8325 16.1463 13.8794 16.1932 13.9383 16.2185C13.9456 16.2203 13.974 16.2264 14.0409 16.231C14.1489 16.2384 14.2937 16.2388 14.537 16.2388C14.7802 16.2388 14.9251 16.2384 15.0331 16.231C15.0999 16.2264 15.1283 16.2203 15.1357 16.2185C15.1945 16.1932 15.2414 16.1463 15.2667 16.0875C15.2685 16.0801 15.2746 16.0517 15.2792 15.9849C15.2866 15.8769 15.287 15.732 15.287 15.4888V10.4888C15.287 10.2455 15.2866 10.1007 15.2792 9.99267C15.2746 9.92583 15.2685 9.89743 15.2667 9.89008C15.2414 9.83125 15.1945 9.78435 15.1357 9.75908C15.1283 9.75721 15.0999 9.75111 15.0331 9.74655C14.9251 9.73918 14.7802 9.73877 14.537 9.73877C14.2937 9.73877 14.1489 9.73918 14.0409 9.74655C13.974 9.75111 13.9456 9.75721 13.9383 9.75907Z"
                          fill="#333"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M10.0982 8.26112C9.93289 8.24984 9.73604 8.24985 9.52176 8.24987H9.47824C9.26397 8.24985 9.06712 8.24984 8.90179 8.26112C8.72415 8.27324 8.52881 8.30086 8.33031 8.38308C7.90151 8.56069 7.56083 8.90137 7.38321 9.33017C7.30099 9.52867 7.27338 9.72401 7.26126 9.90166C7.24998 10.067 7.24999 10.2638 7.25 10.4781V15.5216C7.24999 15.7359 7.24998 15.9328 7.26126 16.0981C7.27338 16.2757 7.30099 16.4711 7.38321 16.6696C7.56083 17.0984 7.90151 17.439 8.33031 17.6167C8.52881 17.6989 8.72415 17.7265 8.90179 17.7386C9.06712 17.7499 9.26396 17.7499 9.47824 17.7499H9.52176C9.73604 17.7499 9.93289 17.7499 10.0982 17.7386C10.2759 17.7265 10.4712 17.6989 10.6697 17.6167C11.0985 17.439 11.4392 17.0984 11.6168 16.6696C11.699 16.4711 11.7266 16.2757 11.7387 16.0981C11.75 15.9328 11.75 15.7359 11.75 15.5216V10.4781C11.75 10.2638 11.75 10.067 11.7387 9.90166C11.7266 9.72401 11.699 9.52867 11.6168 9.33017C11.4392 8.90137 11.0985 8.56069 10.6697 8.38308C10.4712 8.30086 10.2759 8.27324 10.0982 8.26112ZM8.90131 9.77017C8.84248 9.79545 8.79558 9.84234 8.77031 9.90118C8.76844 9.90853 8.76234 9.93693 8.75778 10.0038C8.75041 10.1118 8.75 10.2566 8.75 10.4999V15.4999C8.75 15.7431 8.75041 15.888 8.75778 15.996C8.76234 16.0628 8.76844 16.0912 8.77031 16.0986C8.79558 16.1574 8.84248 16.2043 8.90131 16.2296C8.90867 16.2314 8.93707 16.2375 9.0039 16.2421C9.11191 16.2495 9.25677 16.2499 9.5 16.2499C9.74323 16.2499 9.8881 16.2495 9.9961 16.2421C10.0629 16.2375 10.0913 16.2314 10.0987 16.2296C10.1575 16.2043 10.2044 16.1574 10.2297 16.0986C10.2316 16.0912 10.2377 16.0628 10.2422 15.996C10.2496 15.888 10.25 15.7431 10.25 15.4999V10.4999C10.25 10.2566 10.2496 10.1118 10.2422 10.0038C10.2377 9.93693 10.2316 9.90853 10.2297 9.90117C10.2044 9.84234 10.1575 9.79545 10.0987 9.77017C10.0913 9.7683 10.0629 9.7622 9.9961 9.75764C9.8881 9.75027 9.74323 9.74987 9.5 9.74987C9.25677 9.74987 9.11191 9.75027 9.0039 9.75764C8.93707 9.7622 8.90867 9.7683 8.90131 9.77017Z"
                          fill="#333"
                        />
                      </svg>
                    </div>
                    <div class="groupLabel">توقف در مسیر</div>
                  </div>
                  <div class="groupInputWrapper">
                    <input
                      type="text"
                      class="groupInput timeInput"
                      maxlength="3"
                      v-model="StopMinutesPrice"
                      @keyup="CalculateKM"
                      inputmode="numeric"
                    />
                    <div class="wrapperLabel">دقیقه</div>
                  </div>
                </div>
                <!-- <div class="ShowInputTextRefSheet">
                    <input
                      type="text"
                      maxlength="11"
                      v-model="phone"
                      class="InputX"
                    />
                    <p>تلفن تماس</p>
                  </div> -->

                <!-- <div class="ShowInputTextRefSheet">
                    <input
                      type="text"
                      maxlength="3"
                      v-model="StopMinutesPrice"
                      @keyup="CalculateKM"
                      class="InputX"
                    />
                    <p>توقف در مسیر</p>
                  </div> -->
                <div class="optionsToggleList">
                  <div class="optionToggleThumb">
                    <div class="thumbIcon">
                      <svg
                        width="800px"
                        height="800px"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 6.25C12.4143 6.25 12.75 6.58579 12.75 7V9.00002H14.75C15.1642 9.00002 15.5 9.33581 15.5 9.75002C15.5 10.1642 15.1642 10.5 14.75 10.5H12.75V12.5C12.75 12.9142 12.4143 13.25 12 13.25C11.5858 13.25 11.25 12.9142 11.25 12.5V10.5H9.25003C8.83581 10.5 8.50003 10.1642 8.50003 9.75002C8.50003 9.33581 8.83581 9.00002 9.25003 9.00002H11.25V7C11.25 6.58579 11.5858 6.25 12 6.25Z"
                          fill="#333"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M11.7841 1.25C7.47087 1.25 3.87872 4.55824 3.52439 8.85685C3.33405 11.166 4.04733 13.4589 5.51399 15.2526L10.307 21.1144C11.1821 22.1845 12.818 22.1845 13.693 21.1144L18.4861 15.2526C19.9527 13.4589 20.666 11.166 20.4757 8.85685C20.1213 4.55824 16.5292 1.25 12.216 1.25H11.7841ZM5.01932 8.98008C5.30952 5.45948 8.25152 2.75 11.7841 2.75H12.216C15.7485 2.75 18.6905 5.45948 18.9807 8.98008C19.1391 10.9019 18.5455 12.8102 17.3248 14.3031L12.5318 20.1649C12.2569 20.501 11.7431 20.501 11.4683 20.1649L6.67521 14.3031C5.45455 12.8102 4.8609 10.9019 5.01932 8.98008Z"
                          fill="#333"
                        />
                      </svg>
                    </div>
                    <div class="thumbContent">
                      <div class="contentTitle">مقصد دوم</div>
                      <div class="contentSwitch">
                        <vs-switch
                          id="2"
                          v-model="Lastmarker"
                          v-if="!Lastmarker"
                          @click="NextStep3"
                          color="success"
                        >
                          <!-- <template v-slot:on>
                            <span>دارد</span>
                          </template>

                          <template v-slot:off>
                            <span>ندارد</span>
                          </template> -->
                        </vs-switch>

                        <vs-switch
                          v-model="Lastmarker"
                          v-if="Lastmarker"
                          @click="DeleteRemoveMarker"
                          color="success"
                        >
                          <!-- <template v-slot:on>
                        <span>دارد</span>
                      </template>

                      <template v-slot:off>
                        <span>ندارد</span>
                      </template> -->
                        </vs-switch>
                      </div>
                    </div>
                  </div>
                  <div class="optionToggleThumb">
                    <div class="thumbIcon luggageIcon">
                      <svg
                        version="1.1"
                        id="Icons"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 32 32"
                        xml:space="preserve"
                      >
                        <path
                          class="st0"
                          d="M28,31H18c-1.1,0-2-0.9-2-2V16c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v13C30,30.1,29.1,31,28,31z"
                        />
                        <path
                          class="st0"
                          d="M19,31H4c-1.1,0-2-0.9-2-2v-9c0-1.1,0.9-2,2-2h12"
                        />
                        <line class="st0" x1="16" y1="20" x2="30" y2="20" />
                        <rect x="20" y="1" class="st0" width="6" height="13" />
                        <line class="st0" x1="19" y1="1" x2="27" y2="1" />
                        <line class="st0" x1="6" y1="18" x2="6" y2="31" />
                        <rect x="9" y="15" class="st0" width="4" height="3" />
                      </svg>
                    </div>
                    <div class="thumbContent">
                      <div class="contentTitle">اضافه بار</div>
                      <div class="contentSwitch">
                        <vs-switch
                          v-model="ezafebar"
                          @click="CalculateKM"
                          color="success"
                        >
                          <!-- <template v-if="ezafebar == true" v-slot:on>
                        <span>فعال</span>
                      </template>

                      <template v-if="ezafebar == false" v-slot:off>
                        <span>غیر فعال</span>
                      </template> -->
                        </vs-switch>
                      </div>
                    </div>
                  </div>
                  <div class="optionToggleThumb">
                    <div class="thumbIcon">
                      <svg
                        width="800px"
                        height="800px"
                        viewBox="0 0 32 32"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g fill="none" fill-rule="evenodd">
                          <path d="m0 0h32v32h-32z" />
                          <path
                            d="m23 17v1c0 3.4836886 1.6299243 6.6925042 4.3415908 8.7567524l.2657779.1961637.8132971.5818486-1.1636973 1.6265942-.8132971-.5818486c-3.2931625-2.3559929-5.325229-6.1091405-5.4386588-10.2162282l-.0050126-.3632821v-1zm-12 0v1c0 4.1222573-1.93349498 7.9221443-5.14569975 10.3599231l-.28673163.2115368-.81267957.5827108-1.16542166-1.6253591.81267957-.5827108c2.77556346-1.9901459 4.48845003-5.1491452 4.59279493-8.610242l.00505811-.3358588v-1zm6 0v12h-2v-12zm15-15v14h-32v-14zm-2 2h-28v10h28zm-2 6v2h-24v-2z"
                            fill="#333"
                            fill-rule="nonzero"
                          />
                        </g>
                      </svg>
                    </div>
                    <div class="thumbContent">
                      <div class="contentTitle">کولر</div>
                      <div class="contentSwitch">
                        <vs-switch
                          v-model="koler"
                          @click="CalculateKM"
                          color="success"
                        >
                          <!-- <template v-if="koler == true" v-slot:on>
                        <span>فعال</span>
                      </template>

                      <template v-if="koler == false" v-slot:off>
                        <span>غیر فعال</span>
                      </template> -->
                        </vs-switch>
                      </div>
                    </div>
                  </div>
                  <div class="optionToggleThumb">
                    <div class="thumbIcon">
                      <svg
                        width="800px"
                        height="800px"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 22L10 19M10 19L13 16M10 19H15C18.866 19 22 15.866 22 12C22 9.2076 20.3649 6.7971 18 5.67363M6 18.3264C3.63505 17.2029 2 14.7924 2 12C2 8.13401 5.13401 5 9 5H14M14 5L11 2M14 5L11 8"
                          stroke="#333"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <div class="thumbContent">
                      <div class="contentTitle">رفت و برگشت</div>
                      <div class="contentSwitch">
                        <vs-switch
                          v-model="ExchangeBTN"
                          @click="BtnShowSwitch"
                          color="success"
                        >
                          <!-- <template v-if="ExchangeBTN == true" v-slot:on>
                        <span>فعال</span>
                      </template>

                      <template v-if="ExchangeBTN == false" v-slot:off>
                        <span>غیر فعال</span>
                      </template> -->
                        </vs-switch>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="ShowTypeGoAndBack">
                    <vs-switch
                      v-model="Lastmarker"
                      v-if="!Lastmarker"
                      @click="NextStep3"
                      color="success"
                    >
                      <template v-slot:on>
                        <span>دارد</span>
                      </template>

                      <template v-slot:off>
                        <span>ندارد</span>
                      </template>
                    </vs-switch>

                    <vs-switch
                      v-model="Lastmarker"
                      v-if="Lastmarker"
                      @click="DeleteRemoveMarker"
                      color="success"
                    >
                      <template v-slot:on>
                        <span>دارد</span>
                      </template>

                      <template v-slot:off>
                        <span>ندارد</span>
                      </template>
                    </vs-switch>

                    <p>مقصد دوم</p>
                  </div> -->
                  <!-- <div class="ShowTypeGoAndBack">
                    <vs-switch
                      v-model="ezafebar"
                      @click="CalculateKM"
                      color="success"
                    >
                      <template v-if="ezafebar == true" v-slot:on>
                        <span>فعال</span>
                      </template>

                      <template v-if="ezafebar == false" v-slot:off>
                        <span>غیر فعال</span>
                      </template>
                    </vs-switch>

                    <p>اضافه بار</p>
                  </div> -->
                  <!-- <div class="ShowTypeGoAndBack">
                    <vs-switch
                      v-model="koler"
                      @click="CalculateKM"
                      color="success"
                    >
                      <template v-if="koler == true" v-slot:on>
                        <span>فعال</span>
                      </template>

                      <template v-if="koler == false" v-slot:off>
                        <span>غیر فعال</span>
                      </template>
                    </vs-switch>

                    <p>کولر</p>
                  </div> -->
                  <!-- <div class="ShowTypeGoAndBack">
                    <vs-switch
                      v-model="ExchangeBTN"
                      @click="BtnShowSwitch"
                      color="success"
                    >
                      <template v-if="ExchangeBTN == true" v-slot:on>
                        <span>فعال</span>
                      </template>

                      <template v-if="ExchangeBTN == false" v-slot:off>
                        <span>غیر فعال</span>
                      </template>
                    </vs-switch>

                    <p>رفت و برگشت</p>
                  </div> -->
                </div>
                <div class="optionsFooter">
                  <div class="footerHeader">
                    <div class="headerTitle">هزینه سفر:</div>
                    <div v-if="!LoadingFalse" class="headerValue">
                      {{ formatPrice(TotalGrandTotal1[0]) }} <span>تومان</span>
                    </div>
                    <div v-if="LoadingFalse" class="headerValue valueLoading">
                      <div class="priceLoader"></div>
                    </div>
                  </div>
                  <div class="footerMain">
                    <div
                      class="mainButton"
                      :class="{ disabled: LoadingFalse }"
                      @click="$refs.moreSelect.close()"
                    >
                      تایید
                    </div>
                  </div>
                </div>
                <div>
                  <!-- <div class="ClassLoadingF">
                    <h2 v-if="!LoadingFalse" style="direction: rtl">
                      {{ formatPrice(TotalGrandTotal1[0]) }}
                      <span style="font-size: 0.8rem; color: green">تومان</span>
                    </h2>
                    <span v-if="LoadingFalse" class="loader"></span>
                  </div> -->
                </div>
                <!-- <div
                    class="ShowClickGetTaxiDriver"
                    @click="$refs.moreSelect.close()"
                  >
                    اعمال تغییرات
                  </div> -->
              </div>
            </v-sheet>
          </vue-bottom-sheet>

          <vue-bottom-sheet ref="giftUserCar" style="z-index: 1050">
            <!--              <div style="height:100px;background:#fff">-->
            <!--              <div style="text-align:center">-->
            <!--                <VsxIcon iconName="TicketDiscount" :size="45" :color="color" type="linear"  />-->
            <!--              </div>-->
            <div class="userDiscount">
              <div class="discountInputWrapper">
                <div class="wrapperIcon">
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10.5886 4.0007a1 1 0 0 1 .7069.2926l7.9979 7.9929c.3909.3906.3909 1.0241 0 1.4147l-5.5948 5.5907c-.3906.3903-1.0237.3902-1.4141-.0004l-7.9916-7.9938a.9999.9999 0 0 1-.2928-.707V5.0007c0-.5523.4477-1 1-1h5.5885ZM11.0025 2c.5302 0 1.0387.2105 1.4138.5853l8.9993 8.9936c.7817.7812.7816 2.0483-.0001 2.8294l-7.0104 7.0053c-.7813.7806-2.0473.7803-2.8281-.0007L2.5856 12.419A2 2 0 0 1 2 11.005V4c0-1.1046.8954-2 2-2h7.0025ZM7.502 9.0012c-.83 0-1.5-.6703-1.5-1.5005 0-.8303.67-1.5005 1.5-1.5005s1.5001.6702 1.5001 1.5005c0 .8302-.67 1.5005-1.5 1.5005Z"
                    ></path>
                  </svg>
                </div>
                <input
                  class="wrapperInput"
                  id="inputField"
                  maxlength="10"
                  v-model="code"
                  placeholder="کد تخفیف را وارد کنید"
                />
              </div>
              <div
                v-if="!bon_loading"
                class="ShowLogoInputAndLAbel233"
                @click="set_bon()"
              >
                ثبت کد
              </div>

              <div v-if="bon_loading" class="ShowLogoInputAndLAbel233">
                <span class="whiteLoader"></span>
              </div>
            </div>

            <!--              </div>-->
          </vue-bottom-sheet>

          <vue-bottom-sheet
            ref="reserve_sheet"
            style="z-index: 1050"
            v-model="reserve_sheet"
          >
            <v-sheet class="text-center py-2 px-2" height="33rem">
              <div class="text-center">
                <font-awesome-icon
                  @click="reserve_sheet = false"
                  size="lg"
                  :icon="['fas', 'chevron-down']"
                />
              </div>
              <div style="color: #df1b1b; font-weight: 600" class="mt-3">
                ساعت و زمان رزرو را انتخاب کنید
              </div>

              <div>
                <v-time-picker v-model="reserve" class="mt-4"></v-time-picker>
                {{ reserve }}
              </div>
              <div color="primary" class="mt-2" @click="accept_reserve()">
                تایید زمان رزرو
              </div>
            </v-sheet>
          </vue-bottom-sheet>
        </div>

        <div v-if="step == 4" class="ManualServiceStepOne">
          <div class="ShowStyleFlexStep">
            <div class="ShowStyleFlexStepV" :style="BtnStyle">
              <!-- <VsxIcon
                iconName="SearchNormal1"
                :size="25"
                color="#5584FF"
                type="linear"
              /> -->
              <div>
                <h4 v-if="markerOne == ''" style="font-weight: 400">
                  کجا هستید ؟
                </h4>
                <h4 v-if="markerOne != ''">
                  {{ markerOne.name }}
                </h4>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                  />
                </svg>
              </div>
            </div>
            <div :style="BtnStyle1" class="ShowStyleFlexStepV">
              <!-- <VsxIcon
                iconName="SearchNormal1"
                :size="25"
                color="#5584FF"
                type="linear"
              /> -->
              <div>
                <h4 v-if="markerTwo == ''" style="font-weight: 400">
                  کجا می روید؟
                </h4>
                <h4 v-if="markerTwo != ''">
                  {{ markerTwo.name }}
                </h4>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                  />
                </svg>
              </div>
            </div>
            <div
              @click="OpenModel1"
              :style="BtnStyle2"
              class="ShowStyleFlexStepV"
            >
              <!-- <VsxIcon
                iconName="SearchNormal1"
                :size="25"
                color="#5584FF"
                type="linear"
              /> -->
              <div>
                <h4 v-if="markerThree == ''" style="font-weight: 400">
                  مقصد دومت کجاست ؟
                </h4>
                <h4 v-if="markerThree != ''">
                  {{ markerThree.name }}
                </h4>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                  />
                </svg>
              </div>
            </div>

            <!--              d2 history-->
            <!-- <div v-if="history_map_list.length > 0" class="ShowStyleHistory">
              <div @click="BtnSendData(history_map_list[0], 'history')">
                <h4>{{ history_map_list[0]?.address }}</h4>
                <VsxIcon
                  iconName="Clock"
                  :size="17"
                  color="#5584FF"
                  type="linear"
                />
              </div>
              <hr />
              <div @click="BtnSendData(history_map_list[1], 'history')">
                <h4>{{ history_map_list[1]?.address }}</h4>
                <VsxIcon
                  iconName="Clock"
                  :size="17"
                  color="#5584FF"
                  type="linear"
                />
              </div>
            </div> -->
            <div
              class="BtnSearchNormal1"
              style="margin-bottom: 14px"
              @click="
                ReverseLocationToAddress(
                  markerPosition.latitude,
                  markerPosition.longitude
                )
              "
            >
              تایید مقصد دوم
            </div>
          </div>
        </div>

        <vue-bottom-sheet
          ref="sheet"
          style="z-index: 1050; height: 90% !important"
          v-model="sheet"
        >
          <div class="container listContainer">
            <!-- <div style="margin: auto; width: 95%;"> -->
            <div class="containerHeader">
              <div class="hedaderInputWrapper">
                <input
                  v-model="SearchList1"
                  class="headerInput"
                  placeholder="جستجو"
                />
                <button
                  class="voiceButton"
                  :class="{ listening: isListening }"
                  :style="pulseStyle"
                  @click="startListening"
                >
                  <svg
                    v-if="!isListening"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="size-6"
                  >
                    <path
                      d="M8.25 4.5a3.75 3.75 0 1 1 7.5 0v8.25a3.75 3.75 0 1 1-7.5 0V4.5Z"
                    />
                    <path
                      d="M6 10.5a.75.75 0 0 1 .75.75v1.5a5.25 5.25 0 1 0 10.5 0v-1.5a.75.75 0 0 1 1.5 0v1.5a6.751 6.751 0 0 1-6 6.709v2.291h3a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5h3v-2.291a6.751 6.751 0 0 1-6-6.709v-1.5A.75.75 0 0 1 6 10.5Z"
                    />
                  </svg>
                  <svg
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="size-6"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M6.75 5.25a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75V5.25Zm7.5 0A.75.75 0 0 1 15 4.5h1.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75V5.25Z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div class="list-show-to-user">
              <!-- <div v-if="list.length > 0" class="result-title">
                <span class="title">نتایج جستجو</span>
              </div>

              <div v-if="list.length == 0" class="result-title">
                <span class="title">مکان‌های پیشنهادی</span>
              </div> -->

              <PerfectScrollbar
                style="
                  position: relative !important;
                  right: 0;
                  left: 0;
                  top: 0;
                  bottom: 0;
                  height: 370px;
                  width: auto;
                  margin: auto;
                  padding-bottom: 86px;
                "
                class="ShowToUSerBoxesCq"
              >
                <div v-if="list.length > 0">
                  <div
                    v-for="(lists, index) in list"
                    :key="index"
                    @click="sheet = false"
                  >
                    <div @click="BtnSendData(lists)" class="ShowClassListToUs">
                      <div class="list-item">
                        <div class="details">
                          <div>{{ lists.title }} ({{ lists.region }})</div>
                          <div class="address">{{ lists.address }}</div>
                        </div>

                        <div class="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            class="size-6"
                          >
                            <path
                              fill-rule="evenodd"
                              d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="list.length == 0">
                  <div v-if="history_map_list.length > 0">
                    <div
                      v-for="(lists, index) in history_map_list"
                      :key="index"
                      @click="sheet = false"
                    >
                      <div
                        @click="BtnSendData(lists, 'history')"
                        class="ShowClassListToUs"
                      >
                        <div class="list-item">
                          <div class="details">
                            <div class="address">{{ lists.address }}</div>
                          </div>

                          <div class="icon mt0">
                            <VsxIcon
                              iconName="Clock"
                              :size="16"
                              color="#000"
                              type="bold"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-else class="noHistoryWrapper">
                    <div class="noHistoryThumb">
                      <div class="thumbIcon">
                        <svg
                          width="152px"
                          height="91px"
                          viewBox="0 0 152 91"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <defs>
                            <circle id="path-1" cx="24.5" cy="24.5" r="24.5" />
                            <circle id="path-3" cx="24.5" cy="24.5" r="24.5" />
                          </defs>
                          <g
                            id="Ride-Request"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <g
                              id="Request/Search---No-Result"
                              transform="translate(-105.000000, -280.000000)"
                            >
                              <g
                                id="Place-holder"
                                transform="translate(74.000000, 280.000200)"
                              >
                                <g
                                  id="Illus/empity-search"
                                  transform="translate(31.500200, 0.000000)"
                                >
                                  <g
                                    id="Group"
                                    transform="translate(54.000000, 17.000000)"
                                  >
                                    <g id="Oval-2">
                                      <mask id="mask-2" fill="white">
                                        <use xlink:href="#path-1" />
                                      </mask>
                                      <use
                                        id="Mask"
                                        fill="#FAFAFA"
                                        xlink:href="#path-1"
                                      />
                                      <mask id="mask-4" fill="white">
                                        <use xlink:href="#path-3" />
                                      </mask>
                                      <circle
                                        stroke="#EDEDED"
                                        stroke-width="2.8"
                                        cx="24.5"
                                        cy="24.5"
                                        r="23.1"
                                      />
                                    </g>
                                    <path
                                      d="M34.3196939,11.2388505 C31.5759019,9.20375987 28.1785275,8 24.5,8 C22.9297504,8 21.4107317,8.21934576 19.9719125,8.62906867"
                                      id="Oval"
                                      stroke="#EDEDED"
                                      stroke-width="2.8"
                                      stroke-linecap="round"
                                    />
                                    <path
                                      d="M45,43 C45.4666667,43.2129491 45.9333333,43.3194236 46.4,43.3194236 C46.8666667,43.3194236 47.3333333,43.2129491 47.8,43 L47.8,52.6 C47.8,53.3731986 47.1731986,54 46.4,54 C45.6268014,54 45,53.3731986 45,52.6 L45,43 L45,43 Z"
                                      id="Rectangle"
                                      fill="#EDEDED"
                                      transform="translate(46.400000, 48.500000) rotate(-45.000000) translate(-46.400000, -48.500000) "
                                    />
                                  </g>
                                  <path
                                    d="M38.4,40 L51.2857143,40 L51.2857143,40 L51.2857143,42.8 L38.4,42.8 C37.6268014,42.8 37,42.1731986 37,41.4 C37,40.6268014 37.6268014,40 38.4,40 Z"
                                    id="Rectangle"
                                    fill="#F7F7F7"
                                  />
                                  <path
                                    d="M44.4,48 L52,48 L52,48 L53,50.8 L44.4,50.8 C43.6268014,50.8 43,50.1731986 43,49.4 C43,48.6268014 43.6268014,48 44.4,48 Z"
                                    id="Rectangle"
                                    fill="#F7F7F7"
                                  />
                                  <path
                                    d="M39.4,56 L56.4814815,56 L56.4814815,56 L58,58.8 L39.4,58.8 C38.6268014,58.8 38,58.1731986 38,57.4 C38,56.6268014 38.6268014,56 39.4,56 Z"
                                    id="Rectangle"
                                    fill="#F7F7F7"
                                  />
                                  <rect
                                    id="Rectangle"
                                    fill="#F7F7F7"
                                    x="32"
                                    y="56"
                                    width="4"
                                    height="2.8"
                                    rx="1.4"
                                  />
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </div>
                      <div class="thumbTitle">سابقه‌ای یافت نشد</div>
                    </div>
                  </div>
                </div>
              </PerfectScrollbar>
            </div>
          </div>
        </vue-bottom-sheet>
      </div>
    </div>
  </div>
  <div v-if="ShowModel" class="ModelShowIconToUserSpan">
    <div class="ChildModelShowIconToUserSpan">
      <img src="@/assets/img/5334827.png" alt="" />

      <h1>
        بــروزرسانی
        <span style="font-size: 1rem; color: rgb(255, 79, 79)">(اجباری)</span>
      </h1>

      <div class="showListTitleNew">
        <div
          v-for="(listChecks, index) in listCheck"
          :key="index"
          class="ChildshowListTitleNew"
        >
          <p>{{ listChecks }}</p>
          <div class="CircleShow"></div>
        </div>
      </div>

      <div class="ButtonClickAndShow56">
        <div
          @click="UpdateProgram()"
          style="background: rgb(255, 71, 71)"
          class="GetButtonClickAndShow"
        >
          <span style="font-size: 1rem; color: #fff">دریافت نسخه جدید</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NeshanMap from "@neshan-maps-platform/vue3-openlayers";
import { fromLonLat, toLonLat } from "@neshan-maps-platform/ol/proj";
import Feature from "@neshan-maps-platform/ol/Feature";
import Point from "@neshan-maps-platform/ol/geom/Point";
import VectorSource from "@neshan-maps-platform/ol/source/Vector";
import VectorLayer from "@neshan-maps-platform/ol/layer/Vector";
import { Style, Icon } from "@neshan-maps-platform/ol/style";
import { mapGetters } from "vuex";
import axios from "axios";
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import "@webzlodimir/vue-bottom-sheet/dist/style.css";
import { registerPlugin } from "@capacitor/core";
const BackgroundGeolocation = registerPlugin("BackgroundGeolocation");
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import carIcon from "@/assets/img/car.png";
import { App } from "@capacitor/app";
export default {
  name: "manualService",
  components: {
    PerfectScrollbar,
    NeshanMap,
    VueBottomSheet,
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_PUBLIC_PATH,
      NeshanMapLoad: true,
      center: { latitude: 35.6892, longitude: 51.389 },
      markerPosition: { longitude: 0, latitude: 0 },
      isDarkMode: false,
      around_car: [],
      around_loc: [],
      ExchangeBTN: false,
      ezafebar: false,
      koler: false,
      sheet: false,
      sheet3: false,
      sheet4: false,
      reserve_sheet: false,
      choose_car_sheet: false,
      code: "",
      last_sheet: 0,
      LoadingFalse: false,
      LoadingBoxes: true,
      e6: 1,
      step: 1,
      step1: 10,
      step2: "",
      dropArea: null,
      file_list: [],
      loading: false,
      items_subcategory: [],
      items_state: [],
      items_city: [],
      markers: [],
      markerLayer: null,
      SearchList1: "",
      CarType: "lady",
      reloadKey: 0,
      lat: "",
      BtnStyle: "",
      BtnStyle1: "",
      BtnStyle2: "",
      color: "",
      lng: "",
      map: null,
      marker_add: 0,
      marker_add1: 0,
      marker_add2: 0,
      marker1: null,
      marker2: null,
      marker3: null,
      pointmarker: null,
      ReverseLocationToAddress_switch: true,
      list: [],
      Lastmarker: false,
      reserve: "",
      is_reserved: "no",
      markerOne: "",
      markerTwo: "",
      markerThree: "",
      StopMinutesPrice: 0,
      phone: "",
      SearchList: "",
      userBox: "",
      setState: "",
      setState1: [],
      currLocation: "",
      timer: null,
      time: "",

      TotalGrandTotal1: 0,
      TotalGrandTotal: 0,
      mapFare: 0,
      stopPrice: 0,
      discount_price: 0,
      discount_id: 0,
      has_discount: 0,
      snackbar: false,
      snackbar2: false,
      snackbar3: false,
      bon_loading: false,
      text: ``,
      second_destination_lat: "",
      second_destination_lng: "",
      directionDistance: 0,
      directionDuration: 0,
      noTrafficDuration: 0,
      history_map_list: [],
      pub_lat: 0,
      pub_lan: 0,
      fareRange: [],
      service_api: "",
      newListGet: [],
      watcherId: [],
      watcherId2: [],
      ShowModel: false,
      listCheck: ["برنامه نیاز به بروزرسانی دارد"],
      recognition: null,
      isListening: false,
      voiceSrc: this.publicPath + "/audio/start-location.mp3", // فایل صوتی راهنما
      voiceType: "origin",
      audioContext: null,
      analyser: null,
      dataArray: null,
      volumeLevel: 0,
      speechSubscription: null, // برای Cordova Speech Recognition
    };
  },

  watch: {
    SearchList1() {
      clearTimeout(this.timer);
      this.timer = setTimeout(this.SearchLocation, 1000);
    },
    "$store.state.taxi_c_set": {
      handler() {
        if (
          this.$store.state.taxi_c_set.map_info?.map_key != undefined &&
          this.$store.state.taxi_c_set.map_info?.map_service != undefined
        ) {
          this.NeshanMapLoad = true;
          this.service_api = this.$store.state.taxi_c_set.map_info.map_service;
          console.log("firstttttttt");
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.check_currentservice();
    this.get_loc("", "", "f");
  },
  computed: {
    ...mapGetters(["baseUrl"]),
    pulseStyle() {
      if (!this.isListening) return {};
      const minScale = 1;
      const maxScale = 1.2;
      const clampedVolume = Math.min(1, this.volumeLevel || 0);
      const scale = minScale + (maxScale - minScale) * clampedVolume;
      return {
        transform: `scale(${scale})`,
        transition: "transform 0.1s linear",
      };
    },
  },
  mounted() {
    document.addEventListener("deviceready", () => {
      App.getInfo().then((info) => {
        console.log("c_set data:" + this.$store.state.taxi_c_set.app_version);
        if (this.$store.state.taxi_c_set.app_version != info.version) {
          self.ShowModel = true;
        }
      });
    });

    // if (
    //   this.$store.state.taxi_c_set.map_info.map_key != "" &&
    //   this.$store.state.taxi_c_set.map_info.map_service != ""
    // ) {
    //   this.NeshanMapLoad = true;
    //   this.service_api = this.$store.state.taxi_c_set.map_info.map_service;
    // }
    this.load_map_history();
    this.RangeList();
    setInterval(() => {
      this.loadTheme();
    }, 100);
    this.phone = this.$store.state.auth_taxi.mobile;
  },

  methods: {
    startListening() {
      if (this.isListening || this.isPlayingGuide) return;

      let voiecSrc = null;

      if (this.step1 === 10 || this.step1 === 1) {
        voiecSrc = this.publicPath + "/audio/start-location.mp3";
      } else if (this.step1 === 2) {
        voiecSrc = this.publicPath + "/audio/destination-location.mp3";
      } else if (this.step1 === 3) {
        voiecSrc = this.publicPath + "/audio/second-destination-location.mp3";
      } else {
        voiecSrc = this.publicPath + "/audio/start-location.mp3";
      }

      this.guideAudio = new Audio(voiecSrc);

      this.isPlayingGuide = true;
      this.guideAudio.play();

      this.guideAudio.onended = () => {
        this.isPlayingGuide = false;
        this._checkPermissionAndListen();
      };

      this.guideAudio.onerror = () => {
        console.error("خطا در پخش فایل راهنما");
        this.isPlayingGuide = false;
        this._checkPermissionAndListen();
      };
    },
    _checkPermissionAndListen() {
      if (!window.plugins || !window.plugins.speechRecognition) {
        toast("امکان دسترسی به میکروفن وجود ندارد", {
          type: "error",
        });
        return;
      }

      window.plugins.speechRecognition.hasPermission((hasPermission) => {
        if (!hasPermission) {
          window.plugins.speechRecognition.requestPermission(
            () => {
              console.log("مجوز داده شد");
              this.beginListening();
            },
            (err) => {
              console.error("عدم دریافت مجوز:", err);
            }
          );
        } else {
          this.beginListening();
        }
      });
    },
    beginListening() {
      this.isListening = true;
      window.plugins.speechRecognition.startListening(
        (matches) => {
          console.log("تشخیص داده شده:", matches);
          const result = matches[0] || "هیچ متنی تشخیص داده نشد";
          this.SearchList1 = result;
          this.isListening = false;
        },
        (err) => {
          console.error("خطا در تشخیص:", err);
          this.isListening = false;
        },
        {
          language: "fa-IR",
          matches: 1,
          showPopup: false,
        }
      );
    },

    stopListening() {
      if (window.plugins && window.plugins.speechRecognition) {
        this.isListening = false;
        window.plugins.speechRecognition.stopListening(
          () => {
            console.log("ضبط متوقف شد");
            this.isListening = false;
          },
          (err) => {
            console.error("خطا در توقف:", err);
          }
        );
      }
    },
    getmounted(map) {
      console.log("loaded");
      this.map = map;

      // Add a small delay to ensure map is properly initialized
      setTimeout(() => {
        this.LoadingBoxes = false;

        let self = this;
        self.map = map;
        self.getInfo();
        // if(this.$store.state.taxi_c_set)
        self.componentWillMount(map);

        // self.dropArea = document.getElementById('drop-area');

        // Initialize map layers
        this.markerLayer = new VectorLayer({
          source: new VectorSource(),
        });

        map.addLayer(this.markerLayer);

        // Set initial view
        const view = map.getView();
        view.animate({
          center: fromLonLat([this.center.longitude, this.center.latitude]),
          zoom: 14,
          duration: 100,
        });

        map.on("movestart", () => {
          const marker = document.querySelector(".markerTY");
          if (marker) {
            marker.classList.add("dragging");
          }
        });

        // Add map event listeners
        map.on("moveend", () => {
          const view = map.getView();
          const centerCoordinates = view.getCenter();
          const [longitude, latitude] = toLonLat(centerCoordinates);
          this.markerPosition = { longitude, latitude };

          const marker = document.querySelector(".markerTY");
          if (marker) {
            marker.classList.remove("dragging");
          }
        });
        this.around_customer_car();
      }, 2000);
    },
    async around_customer_car() {
      let self = this;
      try {
        this.watcherId2 = await BackgroundGeolocation.addWatcher(
          {
            requestPermissions: true,
            stale: true,
          },
          (location, error) => {
            var lat = location.latitude;
            var long = location.longitude;
            self.pub_lat = lat;
            self.pub_lan = long;
            self.map.getView().setCenter(fromLonLat([long, lat]));
            //search around car
            this.helperGet_taxi(
              "customer-around-driver-list",
              "lat=" + lat + "&lng=" + long
            ).then(function (r) {
              console.log("r", r);
              self.around_loc = r.data.data;
              if (r.data.result == "1") {
                self.around_loc.forEach(function (value) {
                  const marker = new Feature({
                    geometry: new Point(
                      fromLonLat([value.longitude, value.latitude])
                    ),
                  });
                  const markerStyle = new Style({
                    image: new Icon({
                      src: carIcon,
                      scale: 0.5,
                      anchor: [0.5, 0.5],
                      anchorXUnits: "fraction",
                      anchorYUnits: "fraction",
                    }),
                  });
                  marker.setStyle(markerStyle);
                  const vectorSource = new VectorSource({
                    features: [marker],
                  });
                  if (self.vehicleMarker) {
                    self.map.removeLayer(self.vehicleMarker);
                  }
                  self.vehicleMarker = new VectorLayer({
                    source: vectorSource,
                    zIndex: 2,
                  });
                  if (self.map) {
                    self.map.addLayer(self.vehicleMarker);
                  }
                });
              }
            });
            if (error) {
              console.error("Error getting location:", error);
              return;
            }
          }
        );
        BackgroundGeolocation.removeWatcher({ id: this.watcherId2 });
      } catch (error) {
        console.error("Error adding watcher:", error);
      }
    },

    loadTheme() {
      const savedTheme = localStorage.getItem("theme");
      if (this.savedTheme1 !== savedTheme) {
        this.savedTheme1 = savedTheme;
        if (savedTheme == "light") {
          this.isDarkMode = false;
        } else {
          this.isDarkMode = true;
        }
        this.reloadKey += 1;
      }

      if (savedTheme == "light") {
        this.color = "#6293FF";
      } else {
        this.color = "#BB86FC";
      }
    },
    async get_loc(latitude, longitude, from, isrev) {
      let self = this;
      var lat = self.pub_lat;
      var long = self.pub_lan;

      if (from == "s") {
        lat = latitude;
        long = longitude;
      }
      if (from == "f") {
        let self = this;
        try {
          this.watcherId = await BackgroundGeolocation.addWatcher(
            {
              requestPermissions: true,
              stale: true,
            },
            (location, error) => {
              lat = location.latitude;
              long = location.longitude;
              longitude;
              self.pub_lat = lat;
              self.pub_lan = long;
              self.map.getView().setCenter(fromLonLat([long, lat]));
              if (error) {
                console.error("Error getting location:", error);
                return;
              }
            }
          );
          BackgroundGeolocation.removeWatcher({ id: this.watcherId });
        } catch (error) {
          console.error("Error adding watcher:", error);
        }
      }
      if (isrev == "t") {
        setTimeout(function () {
          self.map.getView().setCenter(fromLonLat([long, lat]));
        }, 1000);
      }
    },
    check_currentservice() {
      let self = this;
      this.helperGet_taxi(
        "customer-current-service-info",
        "uid=" + this.$store.state.auth_taxi.uid
      ).then(function (r) {
        console.log("ccc", r);
        if (r.data.result != 0) {
          self.$store.commit("current_service_set", r);

          console.log(
            "status:sds" +
              self.$store.state.current_service_info.data.data.ac_price
          );

          self.$router.push({
            name: "waiting_driver",
          });
        }
      });
    },
    set_bon() {
      this.bon_loading = true;
      if (!this.code) {
        toast("کد تخفیف وارد نشده است", {
          autoClose: 3000,
          position: "top-right",
          type: "error",
        });
        this.bon_loading = false;
        return;
      }

      if (this.has_discount == 1) {
        toast("کد تخفیف قبلا وارد شده است", {
          autoClose: 3000,
          position: "top-right",
          type: "error",
        });
        this.bon_loading = false;
        return;
      }

      this.helperPost_taxi("customer-check-discount", {
        uid: this.userBox.uid,
        code: this.code,
      })
        .then((r) => {
          if (r.data.result == 1) {
            var discount_id = r.data.data.discount_id;
            var discount_percent = r.data.data.discount_percent;
            var max_discount = r.data.data.max_discount;
            var GrandTotal = this.TotalGrandTotal1[0];
            var discount_price = 0;

            if (GrandTotal <= max_discount) {
              discount_price = (GrandTotal * discount_percent) / 100;
              this.discount_price = discount_price;
              this.discount_id = discount_id;
              this.has_discount = 1;

              toast("کد تخفیف با موفقیت اعمال شد", {
                autoClose: 3000,
                position: "top-right",
                type: "success",
              });
              this.CalculateKM();
            } else {
              toast("مبلغ سرویس شامل کد تخفیف نمی شود", {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }

            this.$refs.giftUserCar.close();
          }
          if (r.data.result == 0) {
            toast(r.data.msg, {
              autoClose: 3000,
              position: "top-right",
              type: "error",
            });
          }
          this.bon_loading = false;
        })
        .catch(function () {});
    },
    choose_car(price, type) {
      this.CarType = type;
      this.TotalGrandTotal1 = [price, type];
    },
    req_car() {
      let self = this;
      self.loading = true;
      let newParam = {};
      newParam.token = this.userBox.token;
      newParam.car_type = this.CarType;
      newParam.mobile = this.userBox.mobile;
      newParam.uid = self.$store.state.auth_taxi.uid;
      newParam.nickname = this.userBox.nickname;
      newParam.directionDistance = this.directionDistance;
      newParam.directionDuration = this.directionDuration;
      newParam.noTrafficDuration = this.noTrafficDuration;
      newParam.hasAC = this.koler;
      newParam.totalFare = this.TotalGrandTotal1[0];
      newParam.mapFare = this.mapFare;
      newParam.cargoPrice = this.setState1.cargo_price;
      newParam.stopPrice = this.stopPrice;
      newParam.acPrice = this.setState1.ac_price;
      newParam.hasCargo = this.ezafebar;
      newParam.hasReturn = this.ExchangeBTN;
      newParam.night_extra_percent = this.setState1.night_extra_percent;
      newParam.day_extra_percent = this.setState1.day_extra_percent;
      newParam.latitude = this.markerOne.lat;
      newParam.longitude = this.markerOne.lng;
      newParam.origin_title = this.markerOne.name;
      newParam.destination_lat = this.markerTwo.lat;
      newParam.destination_lng = this.markerTwo.lng;
      newParam.destination_title = this.markerTwo.name;
      newParam.second_destination_lat = this.markerThree.lat;
      newParam.second_destination_lng = this.markerThree.lng;
      newParam.second_destination_title = this.markerThree.name;
      newParam.discount = this.discount_price;
      newParam.discount_id = this.discount_id;
      newParam.has_discount = this.has_discount;
      newParam.is_reserved = this.is_reserved;
      newParam.reserved_time = this.reserve;

      this.helperPost_taxi("customer-request-service", newParam)
        .then(function (r) {
          if (r.data.result == "1") {
            console.log(r.data);
            self.$store.commit("current_service_set", r);
            self.$router.push({
              name: "waiting_driver",
            });
          } else {
            self.snackbar = true;
            toast(r.data.msg, {
              autoClose: 3000,
              position: "top-right",
              type: "error",
            });
            this.bon_loading = false;
            return;
          }
          self.loading = false;
        })
        .catch(function () {
          self.loading = false;
        });
    },
    BtnShowSwitch() {
      this.CalculateKM();
    },
    BtnShowIt3() {
      if (this.markerOne != "") {
        if (this.markerTwo != "") {
          // this.sheet3 = !this.sheet3;
          this.$refs.sheet3.open();

          this.CalculateKM();
          this.snackbar = false;
        } else {
          this.snackbar = true;
          this.text = "مقصد دوم انتخاب نشده";
        }
      } else {
        this.snackbar = true;
        this.text = "مقصد دوم انتخاب نشده";
      }
    },
    UpdateProgram() {
      window.location.href = this.$store.state.taxi_c_set.customer_app_link;
    },
    BtnShowIt4() {
      if (this.markerOne != "") {
        if (this.markerTwo != "") {
          this.$refs.sheet4.open();
          this.CalculateKM();
          this.snackbar = false;
        } else {
          this.snackbar = true;
          this.text = "مقصد دوم انتخاب نشده";
        }
      } else {
        this.snackbar = true;
        this.text = "مقصد دوم انتخاب نشده";
      }
    },
    getInfo() {
      this.userBox = this.$store.state.auth_taxi;
    },
    // ================== open modal ======================
    OpenModel1() {
      this.$refs.sheet.open();
    },

    // ================== get marker name ======================
    async ReverseLocationToAddress($lat, $lng) {
      let self = this;
      console.log("lat", $lat, "lng", $lng);
      axios
        .get("https://api.neshan.org/v4/reverse?lat=" + $lat + "&lng=" + $lng, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Api-Key": this.service_api,
          },
        })
        .then((response) => {
          self.setState = response.data.formatted_address;

          console.log("step", self.step1);

          if (self.step1 == 10) {
            self.markerOne = { name: self.setState, lat: $lat, lng: $lng };
            this.mapAction($lat, $lng);
          }
          if (self.step1 == 2) {
            const view = this.map.getView();
            const marker1 = [this.markerOne.lng, this.markerOne.lat];
            const marker2 = [$lng, $lat];

            const distance = this.calculateDistance(marker1, marker2);
            const zoomLevel = this.getZoomLevelFromDistance(distance);

            console.log("Coordinates:", $lng, this.markerOne.lat);

            view.animate({
              center: fromLonLat([$lng, this.markerOne.lat]),
              zoom: zoomLevel,
              duration: 100,
            });

            self.markerTwo = { name: self.setState, lat: $lat, lng: $lng };
            this.mapAction($lat, $lng);
          }
          if (self.step1 == 3) {
            this.markerThree = { name: self.setState, lat: $lat, lng: $lng };
            this.mapAction($lat, $lng);
          }
        });

      this.SearchList1 = "";
      this.list = [];
    },
    calculateDistance(coord1, coord2) {
      const R = 6371e3;
      const lat1 = (coord1[1] * Math.PI) / 180;
      const lat2 = (coord2[1] * Math.PI) / 180;
      const deltaLat = ((coord2[1] - coord1[1]) * Math.PI) / 180;
      const deltaLon = ((coord2[0] - coord1[0]) * Math.PI) / 180;

      const a =
        Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
        Math.cos(lat1) *
          Math.cos(lat2) *
          Math.sin(deltaLon / 2) *
          Math.sin(deltaLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      return R * c;
    },
    getZoomLevelFromDistance(distance) {
      if (distance < 500) return 15;
      if (distance < 2000) return 13;
      if (distance < 5000) return 11;
      return 9;
    },
    // ================== search to get city ======================
    SearchLocation() {
      let self = this;
      var lat = self.pub_lat;
      var lng = self.pub_lan;

      if (!this.SearchList1) {
        // console.error('SearchList1 is empty');
        this.list = [];
        return; // خروج از تابع اگر مقدار خالی است
      }

      axios
        .get(
          "https://api.neshan.org/v1/search?term=" +
            this.SearchList1 +
            "&lat=" +
            lat +
            "&lng=" +
            lng,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "Api-Key": this.service_api,
            },
          }
        )
        .then((response) => {
          // بررسی وضعیت پاسخ
          if (response.data && response.data.items) {
            this.list = response.data.items; // مقداردهی به لیست
          } else {
            console.error("No items found in response");
          }
        })
        .catch((error) => {
          console.error("Error during search:", error); // مدیریت خطا
        });
    },
    // ================== send data to neshan for get data ======================
    async componentWillMount(map) {
      let self = this;
      let data = self.$store.state.taxi_c_set;
      self.pub_lat = data.city_center_lat;
      self.pub_lan = data.city_center_lng;
      self.center = {
        latitude: data.city_center_lat,
        longitude: data.city_center_lng,
      };
      const view = map.getView();
      view.animate({
        center: fromLonLat([data.city_center_lng, data.city_center_lat]),
        zoom: 14,
        duration: 100,
      });

      console.log("qwssss", data);

      this.setState1 = {
        ac_price: data.ac_price,
        cargo_price: parseFloat(data.cargo_price),
        stop_unit: parseFloat(data.stop_price),
        TrafficTime: parseFloat(data.trafficFare),
        KM_price: parseFloat(data.kilometerFare),
        ladyPercent: parseFloat(data.lady_percent),
        luxPercent: parseFloat(data.lux_percent),
        bikePercent: parseFloat(data.bike_percent),
        minServiceFare: parseFloat(data.minServiceFare),
        max_city_area: parseFloat(data.max_city_area),
        plus_destination_fare: parseFloat(data.plus_destination_fare),
        visible: false,
      };

      // BackHandler.addEventListener('hardwareBackPress', this.handleBackButton);
    },
    // ================== add marker ======================
    mapAction: function ($lat, $lng) {
      let self = this;
      if (self.step1 !== 0) {
        self.map.getView().setCenter(fromLonLat([$lng, $lat]));
      }

      setTimeout(() => {
        if (this.step1 === 10 && this.marker_add === 0) {
          this.addMarker($lat, $lng, "marker1.png", this.step1);
          this.marker_add = 1;
          this.markerOne = { name: self.setState, lat: $lat, lng: $lng };
          this.step1 = 2;
          this.NextStep();
        }
      }, 300);

      if (this.step1 === 1 && this.marker_add === 0) {
        this.addMarker($lat, $lng, "marker1.png", this.step1);
        this.marker_add = 1;
        this.markerOne = { name: self.setState, lat: $lat, lng: $lng };
        console.log(this.step1);
      }

      if (this.step1 === 2 && this.marker_add1 === 0) {
        this.addMarker($lat, $lng, "marker2.png", this.step1);
        this.marker_add1 = 1;
        this.NextStep2();
        console.log(this.step1);
      }

      if (this.step1 === 3 && this.marker_add2 === 0) {
        this.addMarker($lat, $lng, "marker3.png", this.step1);
        this.marker_add2 = 1;
        this.SuccessPage3();
        this.Lastmarker = true;
        this.step1 = 11;
      }
    },
    addMarker(lat, lng, markerImage, step) {
      const marker = new Feature({
        geometry: new Point(fromLonLat([lng, lat])),
      });

      marker.set("step", step);
      marker.set("title", "سلام");

      const iconStyle = new Style({
        image: new Icon({
          src: `/img/${markerImage}`,
          scale: 0.8,
        }),
      });

      marker.setStyle(iconStyle);
      this.markerLayer.getSource().addFeature(marker); // افزودن مارکر به منبع لایه
      this.markers.push(marker); // ذخیره مرجع به مارکر

      marker.on("pointerover", (event) => {
        const tooltip = document.getElementById("tooltip");
        const title = marker.get("title"); // دریافت عنوان از مارکر
        tooltip.innerHTML = title; // تنظیم متن
        tooltip.style.display = "block";
        tooltip.style.position = "absolute";
        tooltip.style.left = event.pixel[0] + "px";
        tooltip.style.top = event.pixel[1] + "px";
      });

      marker.on("pointerout", () => {
        const tooltip = document.getElementById("tooltip");
        tooltip.style.display = "none"; // پنهان کردن Overlay
      });
    },
    DeleteRemoveMarker() {
      const step3Markers = this.markers.filter(
        (marker) => marker.get("step") === 3
      );

      if (step3Markers.length === 0) {
        console.log("هیچ مارکری برای حذف وجود ندارد.");
        return;
      }

      step3Markers.forEach((marker) => {
        this.markerLayer.getSource().removeFeature(marker);
        const index = this.markers.indexOf(marker);
        if (index > -1) {
          this.markers.splice(index, 1);
        }
      });

      this.step = 3;
      this.Lastmarker = false;
      this.markerThree = "";
      this.marker3 = null;
      this.step1 = 0;
      this.marker_add2 = 0;
      this.CalculateKM();
    },
    // ================== click on search pop pop 1 ======================
    BtnSendData(lists, from) {
      console.log("lists", lists);
      let self = this;

      let latitud;
      let langtitud;
      if (from == "history") {
        latitud = lists.lat;
        langtitud = lists.lng;
      } else {
        latitud = lists.location.y;
        langtitud = lists.location.x;
      }
      const view = self.map.getView();
      view.animate({
        center: fromLonLat([langtitud, latitud]),
        zoom: 18,
        duration: 100,
      });
      this.$refs.sheet.close();
    },
    // ================== click on search pop pop 2 ======================
    BtnSendData2(lists) {
      // let self = this;
      this.markerTwo = lists;
      this.destination_lat = lists.location.y;
      this.destination_lng = lists.location.x;
      this.step1 = 2;
    },
    // ================== click on search pop pop 2 ======================
    BtnSendData3(lists) {
      // let self = this;

      this.markerThree = lists;
      this.step1 = 3;
    },
    // ================== go to page 2 ======================
    NextStep() {
      let self = this;
      if (self.markerOne != "") {
        self.step = 2;
        self.step1 = 2;
        self.BtnStyle = "";
        self.list = [];
        self.SearchList = "";
      } else {
        self.BtnStyle = "border: 1px solid red";
      }
    },
    // ================== go to page 3 ======================
    NextStep2() {
      let self = this;
      if (self.markerTwo != "") {
        self.CalculateKM();
        self.step = 3;
        self.BtnStyle1 = "";
        self.step1 = 0;
        self.list = [];
        self.SearchList = "";

        // self.pointmarker.remove();
        self.ReverseLocationToAddress_switch = false;
      } else {
        self.BtnStyle1 = "border: 1px solid red";
      }
    },
    // ================== go to page 4 ======================
    NextStep3() {
      if (this.marker_add2 == 0) {
        this.step = 4;
        this.step1 = 3;
        if (this.sheet3 == true) {
          this.last_sheet = 3;
          this.$refs.sheet3.open();
        }
        this.list = [];
        this.SearchList1 = "";
        this.Lastmarker = true;
      }
    },
    NextStep4() {
      if (this.sheet3 == true) {
        this.$refs.sheet3.close();
        this.$refs.moreSelect.close();
        this.$refs.reserve_sheet.open();
        this.last_sheet = 3;
      }
      if (this.sheet4 == true) {
        this.$refs.sheet4.close();
        this.$refs.reserve_sheet.open();
        this.last_sheet = 4;
      }
    },
    accept_reserve() {
      if (this.reserve) {
        if (this.reserve.length == 5) {
          this.reserve = this.reserve + ":00";
        }
        this.is_reserved = "yes";
      } else {
        this.reserve = "";
        this.is_reserved = "no";
      }
      if (this.last_sheet == 3) {
        this.$refs.sheet3.open();
        this.$refs.reserve_sheet.close();
      }
      if (this.last_sheet == 4) {
        this.$refs.sheet4.open();
        this.$refs.reserve_sheet.close();
      }
      this.last_sheet = 0;
    },
    // ================== back to page 3 ======================
    SuccessPage3() {
      let self = this;
      if (this.markerThree != "") {
        this.CalculateKM();
        this.step = 3;
        this.step1 = 0;
        this.BtnStyle2 = "";
        this.list = [];
        self.ReverseLocationToAddress_switch = false;
        // self.pointmarker.remove();
      } else {
        this.BtnStyle2 = "border: 1px solid red";
      }
    },
    // ================== close page 4 ======================
    ClosePage4() {
      if (this.step1 == 2) {
        const step3Markers = this.markers.filter(
          (marker) => marker.get("step") === 10
        );
        if (step3Markers.length === 0) {
          console.log("هیچ مارکری برای حذف وجود ندارد.");
          return;
        }

        step3Markers.forEach((marker) => {
          this.markerLayer.getSource().removeFeature(marker);
          const index = this.markers.indexOf(marker);
          if (index > -1) {
            this.markers.splice(index, 1);
          }
        });

        this.step = 1;
        this.step1 = 10;
        this.markerOne = {};
        this.marker_add = 0;
      }

      if (this.step1 == 0) {
        const step3Markers = this.markers.filter(
          (marker) => marker.get("step") === 2
        );
        if (step3Markers.length === 0) {
          console.log("هیچ مارکری برای حذف وجود ندارد.");
          return;
        }

        step3Markers.forEach((marker) => {
          this.markerLayer.getSource().removeFeature(marker);
          const index = this.markers.indexOf(marker);
          if (index > -1) {
            this.markers.splice(index, 1);
          }
        });

        this.step = 2;
        this.step1 = 2;
        this.markerTwo = {};
        this.marker_add1 = 0;
      }

      if (this.step1 == 11) {
        const step3Markers = this.markers.filter(
          (marker) => marker.get("step") === 3
        );
        if (step3Markers.length === 0) {
          console.log("هیچ مارکری برای حذف وجود ندارد.");
          return;
        }
        step3Markers.forEach((marker) => {
          this.markerLayer.getSource().removeFeature(marker); // حذف از منبع
          const index = this.markers.indexOf(marker);
          if (index > -1) {
            this.markers.splice(index, 1); // حذف از آرایه
          }
        });

        this.Lastmarker = false;
        this.markerThree = "";
        this.marker3 = null;
        this.step = 3;
        this.step1 = 0;
        this.marker_add2 = 0;
        this.markerThree = {};
      }
      this.CalculateKM();
    },
    // ================== remove marker3 in map ======================
    DeleteRemoveReserve() {
      this.reserve = "";
      this.is_reserved = "no";
    },
    // ================== import shahram method ======================
    RangeList() {
      this.helperGet_taxi("customer-get-fare-range-list").then((json) => {
        if (json.data.result == "1") {
          this.fareRange = json.data.data;
        }
      });
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    CalculateKM() {
      let self = this;
      this.LoadingFalse = true;
      var Origin = {
        latitude: self.markerOne.lat,
        longitude: self.markerOne.lng,
      };
      var Destination = {
        latitude: self.markerTwo.lat,
        longitude: self.markerTwo.lng,
      };
      var Destination2 = {
        latitude: self.markerThree.lat,
        longitude: self.markerThree.lng,
      };
      var ExchangeBTN = this.ExchangeBTN;
      this.CalNeshanWithTraficAndWithOutTraffic(
        Origin,
        Destination,
        Destination2,
        ExchangeBTN
      );
    },
    async CalNeshanWithTraficAndWithOutTraffic(
      origin,
      destination,
      Destination2,
      ExchangeBTN
    ) {
      var resultNoTraffic = await this.CalcNeshanNoTraffic(
        origin,
        destination,
        Destination2,
        ExchangeBTN
      );
      console.log("resultNoTraffic", resultNoTraffic);
      var resultWithTraffic = await this.CalcNeshanWithTraffic(origin);
      console.log("resultWithTraffic", resultWithTraffic);
      await this.delay(2000);
      var DurationWthTraffic = parseFloat(resultWithTraffic.Duration);
      var DurationNoTraffic = parseFloat(resultNoTraffic.Duration);
      var DistanceNoTraffic = parseFloat(resultNoTraffic.Distance);
      var maxCityArea = parseFloat(this.setState1.max_city_area);
      var StopMinute = parseFloat(this.StopMinutesPrice);
      var StopUnit = parseFloat(this.setState1.stop_unit);
      var StopPrice = 0;
      if (StopMinute > 0) StopPrice = StopMinute * StopUnit;
      this.stopPrice = StopPrice;
      var MoreDuration = parseFloat(DurationWthTraffic - DurationNoTraffic);
      var CalDuration = parseFloat(MoreDuration * this.setState1.TrafficTime);
      var minServiceFare = this.setState1.minServiceFare;
      var night_extra_percent = parseFloat(this.setState1.night_extra_percent);
      var day_extra_percent = parseFloat(this.setState1.day_extra_percent);
      var total = 0;
      var outCityFare = 0;
      //console.log(DistancewithTraffic, maxCityArea);
      if (DistanceNoTraffic > maxCityArea) {
        var outCityDistance = DistanceNoTraffic - maxCityArea; //0.2
        console.log("outCityDistance", outCityDistance);
        if (outCityDistance < 1) {
          outCityDistance = 1;
        }
        this.fareRange.forEach(function (v) {
          let range_from = v.from;
          let range_to = v.to;
          let range_price = v.price;
          if (range_from <= outCityDistance && outCityDistance <= range_to) {
            outCityFare = parseFloat(outCityDistance * range_price);
            total = parseFloat(minServiceFare + outCityFare);
          }
        });
      } else {
        total = minServiceFare;
      }
      var mapFare = parseFloat(total + CalDuration);
      this.mapFare = mapFare;
      if (mapFare < minServiceFare) mapFare = minServiceFare;
      // console.log('mapFare',mapFare)
      var GrandTotal = parseFloat(mapFare + StopPrice);
      // this.TotalGrandTotal = parseFloat(GrandTotal.toFixed(2)) + (GrandTotal * (AC / 100))

      //check incress fare
      if (day_extra_percent > 0) {
        GrandTotal += GrandTotal * (day_extra_percent / 100);
      }

      if (night_extra_percent > 0) {
        GrandTotal += GrandTotal * (night_extra_percent / 100);
      }

      // //--------------------------------------------------------------------
      //car type incress amount
      var ladyPercent = this.setState1.ladyPercent;
      var bikePercent = this.setState1.bikePercent;
      var luxPercent = this.setState1.luxPercent;
      // var CarType = this.param.CarType;

      var GrandTotalWithPercent1 = 0;
      var GrandTotalWithPercent2 = 0;
      var GrandTotalWithPercent3 = 0;
      var GrandTotalWithPercent4 = 0;
      GrandTotalWithPercent1 = GrandTotal;
      GrandTotalWithPercent2 = GrandTotal * (ladyPercent / 100) + GrandTotal;
      GrandTotalWithPercent3 = GrandTotal * (luxPercent / 100) + GrandTotal;
      GrandTotalWithPercent4 = GrandTotal * (bikePercent / 100) + GrandTotal;
      const userPrice = [];
      userPrice.push(
        GrandTotalWithPercent1,
        GrandTotalWithPercent2,
        GrandTotalWithPercent3,
        GrandTotalWithPercent4
      );
      this.newListGet = [];

      for (let i = 0; i < userPrice.length; i++) {
        this.TotalGrandTotal = 0;
        this.TotalGrandTotal = Math.floor(userPrice[i] / 500) * 500;

        if (this.markerThree.lat) {
          this.TotalGrandTotal += this.setState1.plus_destination_fare;
        }

        if (this.ezafebar == true)
          this.TotalGrandTotal += parseInt(this.setState1.cargo_price);

        if (this.koler == true)
          this.TotalGrandTotal +=
            (this.setState1.ac_price / 100) * this.TotalGrandTotal;

        if (this.ExchangeBTN == true)
          this.TotalGrandTotal += (50 / 100) * this.TotalGrandTotal;

        if (this.has_discount) {
          this.TotalGrandTotal -= this.discount_price;
        }
        let typer;
        if (i == 0) {
          typer = "sedan";
        } else if (i == 1) {
          typer = "lady";
        } else if (i == 2) {
          typer = "airline";
        } else {
          typer = "bike";
        }

        if (this.TotalGrandTotal1[1] == typer) {
          this.TotalGrandTotal1 = [this.TotalGrandTotal, typer];
        }

        if (this.TotalGrandTotal1 == 0) {
          this.TotalGrandTotal1 = [this.TotalGrandTotal, typer];
        }

        this.newListGet.push([this.TotalGrandTotal, typer]);
      }

      this.LoadingFalse = false;
    },
    async CalcNeshanNoTraffic(origin, destination, destination2) {
      this.loadingPrice = true;
      var parameter =
        "?type=car&origin=" + origin.latitude + "," + origin.longitude;
      if (this.markerThree != "") {
        parameter +=
          "&waypoints=" +
          destination.latitude +
          "," +
          destination.longitude +
          "&destination=" +
          destination2.latitude +
          "," +
          destination2.longitude;
      } else {
        parameter +=
          "&destination=" + destination.latitude + "," + destination.longitude;
      }

      let responseNoTraffic = await fetch(
        "https://api.neshan.org/v4/direction/no-traffic" + parameter,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Api-Key": this.service_api,
          },
        }
      );

      let json = await responseNoTraffic.json();
      // console.log('responseNoTraffic',json)
      this.noTrafficDuration = Math.round(
        json.routes[0].legs[0].duration.value / 60
      );
      var legs = json.routes[0].legs;
      var nDirection_distance = 0;
      var dDirection_duration = 0;
      for (var i = 0; i < legs.length; i++) {
        nDirection_distance += parseFloat(legs[i].distance.value);
        dDirection_duration += parseFloat(legs[i].duration.value);
      }
      // console.log('nDirection_distance',nDirection_distance)
      var Distance = Math.round(
        Number(parseFloat(nDirection_distance / 1000)).toFixed(1)
      );
      var Duration = Number(parseFloat(dDirection_duration / 60)).toFixed(0);
      //--------------------------------------------------------------------------
      //Exchange Operations
      var Distance2 = 0;
      var Duration2 = 0;

      var TotalDistance = parseFloat(Distance) + parseFloat(Distance2);
      var TotalDuration = parseFloat(Duration) + parseFloat(Duration2);

      var result = {
        Distance: TotalDistance,
        Duration: TotalDuration,
      };
      return result;
    },
    async CalcNeshanWithTraffic(origin) {
      // check webservice neshan without traffic
      var parameter =
        "?type=car&origin=" + origin.latitude + "," + origin.longitude;
      if (this.markerThree != "") {
        parameter +=
          "&waypoints=" +
          this.markerTwo.lat +
          "," +
          this.markerTwo.lng +
          "&destination=" +
          this.markerThree.lat +
          "," +
          this.markerThree.lng;
      } else {
        parameter +=
          "&destination=" + this.markerTwo.lat + "," + this.markerTwo.lng;
      }
      let responseWithTraffic = await fetch(
        "https://api.neshan.org/v4/direction" + parameter,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Api-Key": this.service_api,
          },
        }
      );
      let json = await responseWithTraffic.json();

      this.directionDistance = Math.round(
        json.routes[0].legs[0].distance.value / 1000
      );
      this.directionDuration = Math.round(
        json.routes[0].legs[0].duration.value / 60
      );
      var legs = json.routes[0].legs;
      var nDirection_distance = 0;
      var dDirection_duration = 0;
      for (var i = 0; i < legs.length; i++) {
        nDirection_distance += parseFloat(legs[i].distance.value);
        dDirection_duration += parseFloat(legs[i].duration.value);
      }
      var Distance = Math.round(
        Number(parseFloat(nDirection_distance / 1000)).toFixed(1)
      );
      var Duration = Number(parseFloat(dDirection_duration / 60)).toFixed(0);
      //------------------------------------------------------------------------
      //Exchange Operations
      var Distance2 = 0;
      var Duration2 = 0;
      var TotalDistance = parseFloat(Distance) + parseFloat(Distance2);
      var TotalDuration = parseFloat(Duration) + parseFloat(Duration2);
      var result = {
        Distance: TotalDistance,
        Duration: TotalDuration,
      };
      return result;
    },
    load_map_history() {
      let self = this;
      this.helperGet_taxi(
        "customer-get-customer-address",
        "uid=" + this.$store.state.auth_taxi.uid
      ).then(function (r) {
        console.log(r.data.data);

        if (r.data.result == "1") {
          self.history_map_list = r.data.data;
        }
      });
    },
    opendiscount() {
      this.$refs.giftUserCar.open();
      const inputField = document.getElementById("inputField");

      inputField.focus(); // تمرکز بر روی input

      // document.getElementById('inputField').focus()
    },
  },
};
</script>

<style scoped lang="scss">
.markerTY {
  position: absolute;
  left: 42%;
  top: 45.7%;
  cursor: pointer;
}

.markerTY img {
  height: 63px;
  pointer-events: none;
}

.TopInputShowType {
  height: 40px;
  width: 90%;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  border: 1px solid #d7d6d6;
  padding: 0 10px;
}

@media screen and (max-width: 800px) {
  .map {
    width: 100% !important;
  }
}

.ListShowToUser {
  padding: 0 26px 0 13px;
  overflow-y: scroll;
  height: 100%;
}

.ChildListShowToUser {
  text-align: right;
  margin-top: 15px;
  transition: 1s ease-in-out;
  border-bottom: 1px solid #ccc;
  padding: 12px 0px;
}

.ChildListShowToUser:hover {
  color: #00bc6e;
  cursor: pointer;
  transition: 1s ease-in-out;
}

.DivCloseButton {
  width: 100%;
  background: red;
  color: white;
  height: 45px;
  line-height: 45px;
  border-radius: 5px;
}

.divClassDivCloseButton {
  margin: auto;
  width: 90%;
  display: grid;
  grid-template-columns: 68% 30%;
  justify-content: space-between;
}

.divClassDivCloseButton1 {
  margin: auto;
  width: 100%;
  display: grid;
  grid-template-columns: 49% 49%;
  justify-content: space-between;
}

.loader {
  width: 23px;
  height: 23px;
  border: 3px dotted #ff0000;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  animation: rotation 2s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.location-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 400;
  color: rgb(104 108 121 / 81%);
  background: white;
  border-radius: 100%;
  height: 40px;
  width: 40px;
  float: right;
  margin-bottom: 10px;
}

.vs-switch--circle {
  height: 25px !important;
}

.vs-switch-success {
  width: 80px !important;
  margin: auto;
  height: 30px;
  background: rgb(218, 83, 83);
}

.vs-switch--text.active-text span {
  padding-left: 7px !important;
  color: #fff;
  font-size: 0.7rem;
}

.vs-switch-success.vs-switch-active {
  background: #1287a5;
}

@import url("@neshan-maps-platform/vue3-openlayers/dist/style.css");

.manualService {
  height: 100vh;
  position: relative;
}

.optionsContainer {
  padding: 0 !important;

  .location-btn {
    width: 42px !important;
    height: 42px !important;
    background: #0851a0 !important;
    margin-right: 16px !important;
    margin-left: auto !important;
    box-shadow: 1px 2px 4px 0px rgba(0, 0, 0, 0.35) !important;
    float: none;
  }

  .ManualServiceStepOne {
    background: #fff;
    padding: 24px 16px 16px;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    box-shadow: 1px -2px 4px 4px rgba(0, 0, 0, 0.15) !important;

    &.secondStep {
      padding-bottom: 24px;
    }

    .ShowStyleFlexStep {
      .ShowStyleFlexStepV {
        background: #f7f7f7 !important;
        border-radius: 16px !important;
        border: 1px solid #dedede !important;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15) !important;
        display: block !important;
        padding: 0 !important;

        & > div {
          width: 100%;
          height: 100% !important;
          display: flex;
          align-items: center;
          gap: 4px;
          justify-content: right;
          padding: 12px !important;

          svg {
            width: 20px;
            height: 20px;
            stroke: #a4a4a4;
            stroke-width: 2;
          }

          h4 {
            font-size: 0.85rem !important;
          }
        }
      }

      .BtnSearchNormal1 {
        width: 100%;
        height: 50px;
        border-radius: 16px;
        color: #fff;
        font-size: 1rem;
        font-weight: 500;
        background: #0851a0;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
        margin-top: 16px;
      }
    }

    .destionationThumb {
      width: 100%;
      display: flex;
      align-items: flex-start;
      gap: 16px;
      direction: rtl;
      border-bottom: 1px solid #dedede;

      &.beforeLastmarker {
        border-bottom: none !important;
      }

      &.Lastmarker {
        border-bottom: none !important;
      }

      .thumbIcon {
        width: 16px;
        height: 16px;
        position: relative;
        background: #0851a0;
        flex-shrink: 0;
        margin-top: 14px;

        &.circle {
          border-radius: 50%;

          &::before {
            border-radius: 50%;
          }
        }

        &.square {
          border-radius: 4px;

          &::before {
            border-radius: 1px;
          }
        }

        &::before {
          content: "";
          display: block;
          width: 6px;
          height: 6px;
          background: #fff;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .thumbInfo {
        flex-grow: 1;
        display: flex;
        align-items: flex-start;
        gap: 4px;
        padding: 10px 0;

        &.infoTitle {
          align-items: center;
        }

        .thumbTitle {
          font-family: "iranyekanB", sans-serif;
          font-size: 0.9rem;
          color: #000;
          flex-shrink: 0;
        }

        .thumbValue {
          font-size: 0.9rem;
          color: #555;
        }
      }
    }

    .BtnSearchNormal1 {
      width: 100%;
      height: 50px;
      border-radius: 16px;
      color: #fff;
      font-size: 1rem;
      font-weight: 500;
      background: #0851a0;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
      margin-top: 16px;
    }
  }
}

.classShowTypeCar {
  &.travelTypesList {
    height: 98px !important;
  }
}

.typeThumb {
  direction: rtl;
  color: #000;
  width: calc(100% - 32px);
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 8px;
  transition: all 0.2s;

  &:not(:last-child) {
    border-bottom: 1px solid #dedede;
  }

  &.noBorder {
    border: none !important;
  }

  &.active {
    border: 1px solid #c4c4c4;
    border-radius: 8px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    background: #f7f7f7;
  }

  .thumbInfo {
    display: flex;
    align-items: center;
    gap: 12px;

    .infoIcon {
      width: 64px;
      height: 64px;
      background: #0851a0;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      &.bikeIcon {
        img {
          width: 74%;
          transform: rotateY(180deg);
        }
      }

      &.womenIcon {
        img {
          transform: rotateY(180deg);
        }
      }

      &.premiumIcon {
        img {
          width: 100%;
        }
      }

      img {
        width: 90%;
      }
    }

    .infoContent {
      .contentTitle {
        font-family: "iranyekanB", sans-serif;
        font-size: 1.05rem;
      }

      .contentSubtitle {
        font-size: 0.8rem;
        text-align: right;
      }
    }
  }

  .thumbPrice {
    font-family: "yekan", sans-serif;
    font-size: 1.15rem;
    font-weight: 700;

    span {
      font-family: "iranyekan", sans-serif;
      font-size: 0.8rem;
      font-weight: 400;
    }

    &.thumbPriceLaoding {
      width: 48px;
    }
  }
}

.RightSelectButtonGEt {
  height: 82px !important;
  box-shadow: 0 -4px 4px rgba(0, 0, 0, 0.15);
  border-radius: 0 !important;
  margin-top: 16px;

  .ChildRightSelectButtonGEt {
    position: relative;
    height: 100% !important;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    svg {
      width: 26px;
      height: 26px;
      margin-top: 12px;
      fill: #0851a0;
    }

    &:first-child {
      border: none !important;

      &::after {
        content: "";
        display: block;
        width: 1px;
        height: 62px;
        background: #dedede;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-40%);
      }
    }
  }
}

.travelCustomOptions {
  width: 100%;
  margin-bottom: 24px;
  direction: rtl;

  .optionsInputGroup {
    width: calc(100% - 32px);
    padding: 4px 0;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    align-items: center;
    gap: 12px;
    border-bottom: 1px solid #eaeaea;

    .groupLabelWrapper {
      flex-grow: 0;
      display: flex;
      align-items: center;
      gap: 12px;

      .labelIcon {
        padding-top: 4px;
        svg {
          width: 24px;
          height: 24px;
        }
      }
    }

    .groupLabel {
      flex-shrink: 0;
      font-size: 0.9rem;
      color: #333;
      text-align: right;
    }

    .groupInputWrapper {
      position: relative;
      flex-grow: 1;
      .groupInput {
        width: 100%;
        height: 44px !important;
        background: #fff;
        padding: 12px 12px;
        font-size: 0.9rem;
        direction: ltr;
        text-align: left;

        &.timeInput {
          padding-left: 62px;
        }

        &:focus {
          background: #fff !important;
        }
      }

      .wrapperLabel {
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        height: 100%;
        padding: 0 12px;
        z-index: 2;
        font-size: 0.8rem;
        color: #000;
      }
    }
  }

  .optionsToggleList {
    margin: 0 0 16px;
    padding: 0 16px;
    direction: rtl;
    color: #000;

    .optionToggleThumb {
      display: flex;
      align-items: center;
      gap: 12px;

      &:not(:last-child) {
        border-bottom: 1px solid #eaeaea;
      }

      .thumbIcon {
        flex-shrink: 0;
        padding-top: 8px;

        &.luggageIcon {
          .st0 {
            fill: none;
            stroke: #333;
            stroke-width: 2;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-miterlimit: 10;
          }
        }

        svg {
          width: 24px;
          height: 24px;
        }
      }

      .thumbContent {
        flex-grow: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 14px 0;

        .contentTitle {
          font-family: "iranyekan", sans-serif;
          font-size: 0.9rem;
          color: #333;
        }

        .contentSwitch {
          padding-left: 8px;

          :deep(.vs-switch-success) {
            width: 42px !important;
            height: 12px !important;
            background: #e1e1e1 !important;
            border-radius: 9999px !important;

            &.vs-switch-active {
              background: #0851a0 !important;
            }

            .vs-switch--circle {
              top: -3px !important;
              box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px,
                rgba(0, 0, 0, 0.1) 0px 2px 4px 0px,
                rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset !important;
            }
          }
        }
      }
    }
  }

  .optionsFooter {
    width: 100%;
    padding: 16px 16px 0;
    box-shadow: 0 -4px 4px rgba(0, 0, 0, 0.15);

    .footerHeader {
      width: 96%;
      margin-left: auto;
      margin-right: auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;

      .headerTitle {
        color: #545454;
        font-size: 0.9rem;
      }

      .headerValue {
        font-family: "iranyekanB", sans-serif;
        font-size: 1.05rem;
        color: #000;

        span {
          font-family: "iranyekan", sans-serif;
          font-size: 0.8rem;
        }

        &.valueLoading {
          height: 28.8px;
          width: 42px;
          padding-top: 14px;
        }
      }
    }

    .footerMain {
      .mainButton {
        width: 100%;
        height: 50px !important;
        border-radius: 16px;
        color: #fff;
        font-size: 1rem;
        font-weight: 500;
        background: #0851a0;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
        transition: all 0.15s;

        &.disabled {
          pointer-events: none;
          background: #c4c4c4;
        }
      }
    }
  }
}

.userDiscount {
  width: 100%;
  padding: 8px 16px;
  margin-bottom: 24px;

  .discountInputWrapper {
    position: relative;
    .wrapperInput {
      width: 100%;
      height: 44px !important;
      background: #f7f7f7;
      border: 1px solid #dedede !important;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15) !important;
      padding: 12px 46px 12px 16px;
      font-size: 0.9rem;
      border-radius: 10px;
      transition: all 0.25s;

      &:focus {
        background: #fff !important;
      }
    }

    .wrapperIcon {
      position: absolute;
      right: 0;
      top: 0;
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: none;
      z-index: 2;

      svg {
        width: 24px;
        height: 24px;
        fill: #7a7a7a;
      }
    }
  }

  .ShowLogoInputAndLAbel233 {
    width: 100%;
    height: 50px;
    border-radius: 10px;
    color: #fff !important;
    font-size: 1rem;
    font-weight: 500;
    background: #0851a0;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
    margin-top: 16px;
  }
}

.ShowClickGetTaxiDriver.submitRequestBtn {
  width: calc(100% - 32px) !important;
  height: 50px !important;
  border-radius: 16px;
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
  background: #0851a0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  margin-top: 16px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 24px !important;
}

.light {
  :deep(.bottom-sheet__content) {
    background: #fff !important;
  }
}

.listContainer {
  .containerHeader {
    padding-bottom: 20px;
    border-bottom: 1px solid #dedede;
    .hedaderInputWrapper {
      position: relative;
      width: 90%;
      margin-left: auto;
      margin-right: auto;

      .headerInput {
        width: 100%;
        background: transparent;
        padding: 12px 16px 12px 42px;
        font-size: 1rem;
        transition: all 0.25s;
        text-align: right;
        height: 44px !important;
        border-radius: 8px !important;
        background: #f7f7f7;
        border: 1px solid #dedede !important;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15) !important;
        direction: rtl;
      }

      .voiceButton {
        width: 32px;
        height: 32px;
        background: transparent;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 12px;
        top: 6px;
        z-index: 2;
        color: #0851a0;
        transition: all 0.2s, transform 0.1s ease;

        span {
          display: block;
          width: 24px;
          height: 24px;
        }

        svg {
          width: 24px;
          height: 24px;
          position: relative;
          z-index: 2;
        }

        &::after {
          content: "";
          width: 100%;
          height: 100%;
          position: absolute;
          inset: 0;
          background: #4caf50;
          transition: all 0.2s;
          transform: scale(0);
          border-radius: 50%;
          z-index: 1;
        }

        &.listening {
          color: #fff;
          &::after {
            transform: scale(1);
          }
        }
      }
    }
  }
  .noHistoryWrapper {
    display: flex;
    justify-content: center;
    padding-top: 54px;

    .noHistoryThumb {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;

      .thumbTitle {
        font-size: 1rem;
        color: #797979;
      }
    }
  }

  .list-item {
    margin-top: 0 !important;
    padding: 10px !important;
    border-bottom: 1px solid #ededed !important;
    align-items: flex-start !important;

    .icon {
      margin-top: 4px;
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: #f7f7f7;

      &.mt0 {
        margin-top: 0 !important;
      }

      svg {
        width: 16px;
        height: 16px;
      }
    }
  }
}

.UserCarBon {
  margin-bottom: 92px;
}

.markerTY {
  top: 50.5%;
  left: 50%;
  transform: translate(-50%, -50%);
  .customMarker {
    display: flex;
    align-items: center;
    flex-direction: column;

    &.destination {
      .markerHead {
        background: #276ef1;
      }
      .markerPin {
        background: #276ef1;
      }
      .markerSadow {
        .shadowColored {
          background: rgba(39, 110, 241, 0.3);

          .coloredCenter {
            background: #276ef1;
          }
        }
      }
    }

    &.destination2 {
      .markerHead {
        background: #ff8800;
      }
      .markerPin {
        background: #ff8800;
      }
      .markerSadow {
        .shadowColored {
          background: rgba(255, 136, 0, 0.3);

          .coloredCenter {
            background: #ff8800;
          }
        }
      }
    }

    .markerHead {
      position: relative;
      background: #18a05f;
      display: flex;
      width: 62px;
      height: 36px;
      align-items: center;
      justify-content: center;
      padding: 6px;
      border-radius: 32px;
      box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1);
      transition: all 0.1s ease-out;
      transform-origin: center center;

      .headPoint {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) scale(0);
        transition: all 0.1s ease-out;
        width: 8px;
        height: 8px;
        background: #fff;
        border-radius: 50%;
      }

      .headContainer {
        padding: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.1s;
        transform-origin: 50% 50%;

        span {
          font-size: 0.85rem;
          color: #fff;
          margin: 0 0.5rem;
          line-height: 1.5rem;
          white-space: nowrap;
          font-family: "iranyekanB", sans-serif;
          animation: grow-font 0.2s ease-out forwards;
          transition: all 0.1s;
          transform-origin: 50% 50%;
        }
      }
    }

    .markerPin {
      background: #18a05f;
      width: 3px;
      height: 16px;
      border-radius: 0 0 10px 10px;
      transition: transform 0.1s ease-out, -webkit-transform 0.1s ease-out;
      transform-origin: 50% 50%;
    }

    .markerSadow {
      margin-top: -2px;

      svg {
        width: 12px;
        transition: all 0.1s;
        transform-origin: 50% 50%;
      }

      .shadowColored {
        display: none;
        transform: scale(0);
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: rgba(4, 160, 95, 0.3);
        align-items: center;
        justify-content: center;
        transform-origin: 50% 50%;
        transition: all 0.1s;
        margin-top: -5px;

        .coloredCenter {
          width: 4px;
          height: 4px;
          background: rgb(24, 160, 95);
          border-radius: 50%;
        }
      }
    }
  }

  &.dragging {
    .customMarker {
      .markerHead {
        width: 36px;
        border-radius: 50%;
        transform: translateY(-10px) scale(0.9);

        .headPoint {
          transform: translate(-50%, -50%) scale(1);
        }

        .headContainer {
          transform: scale(0);
          opacity: 0;

          span {
            transform: scale(0);
            opacity: 0;
          }
        }
      }

      .markerPin {
        transform: translateY(-15px);
      }

      .markerSadow {
        .shadowColored {
          transform: scale(1);
          display: flex;
        }

        svg {
          transform: scale(0);
          display: none;
        }
      }
    }
  }
}

@keyframes grow-font {
  from {
    font-size: 0;
  }
  to {
    font-size: 0.85rem;
  }
}

#ClosePage4 {
  box-shadow: 1px 2px 4px 0px rgba(0, 0, 0, 0.35) !important;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  background: #0851a0 !important;
  right: 16px !important;
  color: #fff;
}

.voice-button {
  position: absolute;
  left: 10px;
  background-color: white;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 50%;
  transition: all 0.3s ease;
  top: 50%;
  transform: translateY(-50%);
}

.voice-button .mic-icon {
  width: 24px;
  height: 24px;
  color: #5584ff;
  transition: transform 0.3s ease;
}

.voice-button:hover .mic-icon {
  transform: scale(1.1);
}

.voice-button.listening {
  animation: pulse 1.2s infinite;
  background-color: #f0f8ff;
  box-shadow: 0 0 0 6px rgba(85, 132, 255, 0.2);
}

.voice-button.listening .mic-icon {
  color: #ff4d4f;
}

.mapLoading {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999999;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 77, 79, 0.5);
  }
  70% {
    transform: scale(1.1);
    box-shadow: 0 0 0 12px rgba(255, 77, 79, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 77, 79, 0);
  }
}

@media (min-width: 500px) {
  .AllPwaMobile {
    &.manualService {
      background: transparent !important;
    }
  }
  .ClassPositionLayers {
    width: 100% !important;
  }
}

.sk-cube-grid {
  width: 40px;
  height: 40px;
  margin: 100px auto;
}

.sk-cube-grid .sk-cube {
  width: 33%;
  height: 33%;
  background-color: #0851a0;
  float: left;
  -webkit-animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
  animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
}
.sk-cube-grid .sk-cube1 {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}
.sk-cube-grid .sk-cube2 {
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}
.sk-cube-grid .sk-cube3 {
  -webkit-animation-delay: 0.4s;
  animation-delay: 0.4s;
}
.sk-cube-grid .sk-cube4 {
  -webkit-animation-delay: 0.1s;
  animation-delay: 0.1s;
}
.sk-cube-grid .sk-cube5 {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}
.sk-cube-grid .sk-cube6 {
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}
.sk-cube-grid .sk-cube7 {
  -webkit-animation-delay: 0s;
  animation-delay: 0s;
}
.sk-cube-grid .sk-cube8 {
  -webkit-animation-delay: 0.1s;
  animation-delay: 0.1s;
}
.sk-cube-grid .sk-cube9 {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}

@-webkit-keyframes sk-cubeGridScaleDelay {
  0%,
  70%,
  100% {
    -webkit-transform: scale3D(1, 1, 1);
    transform: scale3D(1, 1, 1);
  }
  35% {
    -webkit-transform: scale3D(0, 0, 1);
    transform: scale3D(0, 0, 1);
  }
}

@keyframes sk-cubeGridScaleDelay {
  0%,
  70%,
  100% {
    -webkit-transform: scale3D(1, 1, 1);
    transform: scale3D(1, 1, 1);
  }
  35% {
    -webkit-transform: scale3D(0, 0, 1);
    transform: scale3D(0, 0, 1);
  }
}
</style>
